{
	"ContentGrid 01": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center gap-2 sm:gap-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 m-2 sm:m-4 p-2 sm:p-4 w-80"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center"
				},
				"imageClass": {
					"translations": {},
					"value": "h-48 object-contain mx-auto rounded"
				},
				"previewHeightClass": {
					"translations": {},
					"value": "h-24"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 0,
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "الأخبار والتحديثات",
				"en": "News & Updates",
				"en-GB": "News & Updates",
				"en-US": "News & Updates",
				"es": "Noticias y actualizaciones",
				"es-419": "Noticias y actualizaciones",
				"es-ES": "Noticias y actualizaciones",
				"he": "חדשות ועדכונים",
				"it": "Notizie e aggiornamenti",
				"pl": "Aktualności i aktualizacje",
				"sw": "Habari na Masasisho",
				"tl": "Balita at Mga Update",
				"vi": "Tin tức & Cập nhật",
				"zh": "新闻与动态"
			},
			"type": "TextInput",
			"value": "News & Updates"
		}
	},
	"ContentGrid 02": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center gap-2 sm:gap-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 m-2 sm:m-4 p-2 sm:p-4"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 md:grid-cols-3"
				},
				"imageClass": {
					"translations": {},
					"value": "hidden"
				},
				"previewHeightClass": {
					"translations": {},
					"value": "h-16"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 1,
		"relatedArticleCategoryLabel": {
			"permission": "Admin",
			"translations": {
				"ar": "مجالات الممارسة",
				"en": "Practice Areas",
				"en-GB": "Practice Areas",
				"en-US": "Practice Areas",
				"es": "Áreas de práctica",
				"es-419": "Áreas de práctica",
				"es-ES": "Áreas de práctica",
				"he": "תחומי עיסוק",
				"it": "Aree di competenza",
				"pl": "Obszary praktyki",
				"sw": "Maeneo ya Mazoezi",
				"tl": "Mga Lugar ng Pagsasanay",
				"vi": "Các lĩnh vực thực hành",
				"zh": "业务领域"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مجالات الممارسة",
				"en": "Areas of Practice",
				"en-GB": "Areas of Practice",
				"en-US": "Areas of Practice",
				"es": "Áreas de práctica",
				"es-419": "Áreas de práctica",
				"es-ES": "Áreas de práctica",
				"he": "תחומי עיסוק",
				"it": "Aree di pratica",
				"pl": "Obszary praktyki",
				"sw": "Maeneo ya Utendaji",
				"tl": "Mga Larangan ng Pagsasagawa",
				"vi": "Các lĩnh vực thực hành",
				"zh": "执业领域"
			},
			"type": "TextInput",
			"value": "Areas of Practice"
		}
	},
	"Features 01": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## الأعلى تقييمًا والأكثر موثوقية\n\nاطلع على آراء عملائنا في تقييماتنا",
						"en": "## Top-Rated & Trusted\n\nSee what clients say in our reviews",
						"en-GB": "## Top-Rated & Trusted\n\nSee what clients say in our reviews",
						"en-US": "## Top-Rated & Trusted\n\nSee what clients say in our reviews",
						"es": "## Excelentes valoraciones y confianza\n\nLea las opiniones de nuestros clientes",
						"es-419": "## Excelentes valoraciones y confianza\n\nLea las opiniones de nuestros clientes",
						"es-ES": "## Excelentes valoraciones y confianza\n\nLea las opiniones de nuestros clientes",
						"he": "## מדורג גבוה ואמין\n\nראו מה לקוחות אומרים בביקורות שלנו",
						"it": "## Valutato al meglio e affidabile\n\nScopri cosa dicono i clienti nelle nostre recensioni",
						"pl": "## Najwyżej oceniane i godne zaufania\n\nZobacz, co klienci mówią w naszych recenzjach",
						"sw": "## Iliyokadiriwa na Kuaminika Zaidi\n\nTazama kile ambacho wateja wanasema katika mapitio yetu",
						"tl": "## Nangunguna at Pinagkakatiwalaan\n\nTingnan ang sinasabi ng mga kliyente sa aming mga review",
						"vi": "## Được đánh giá cao & Đáng tin cậy\n\nXem khách hàng nói gì trong phần đánh giá của chúng tôi",
						"zh": "## 顶级好评，值得信赖\n\n看看客户在我们的评价中怎么说"
					},
					"value": "## Top-Rated & Trusted\n\nSee what clients say in our reviews"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "خمس نجوم بيضاء",
						"en": "Five White Stars",
						"en-GB": "Five White Stars",
						"en-US": "Five White Stars",
						"es": "Cinco estrellas blancas",
						"es-419": "Cinco estrellas blancas",
						"es-ES": "Cinco estrellas blancas",
						"he": "חמישה כוכבים לבנים",
						"it": "Cinque stelle bianche",
						"pl": "Pięć białych gwiazd",
						"sw": "Nyota Tano Nyeupe",
						"tl": "Limang Puting Bituin",
						"vi": "Năm ngôi sao trắng",
						"zh": "五颗白星"
					},
					"value": "Five White Stars"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2001%2FFeature%2001%20Image%2FChatGPT%20Image%20Five%20Stars.png?alt=media&token=ad955be3-a0e2-49d5-b403-a394acfdd7bc",
				"formattedSize": "15.87 KB",
				"height": 62,
				"name": "ChatGPT Image Five Stars.png",
				"path": "uploads/home/Features 01/Feature 01 Image/ChatGPT Image Five Stars.png",
				"query": "?as=run",
				"size": 16252,
				"type": "image/png",
				"updated": "2025-12-24T04:53:46.727Z",
				"width": 361
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## نتائج مثبتة\n\nنركز على تحقيق أفضل النتائج لك",
						"en": "## Proven Results\n\nFocused on your best outcome",
						"en-GB": "## Proven Results\n\nFocused on your best outcome",
						"en-US": "## Proven Results\n\nFocused on your best outcome",
						"es": "Resultados comprobados\n\nEnfocados en sus mejores resultados",
						"es-419": "Resultados comprobados\n\nEnfocados en sus mejores resultados",
						"es-ES": "Resultados comprobados\n\nEnfocados en sus mejores resultados",
						"he": "## תוצאות מוכחות\n\nמתמקדים בתוצאה הטובה ביותר שלך",
						"it": "## Risultati comprovati\n\nConcentrati sul tuo miglior risultato",
						"pl": "## Sprawdzone rezultaty\n\nSkupieni na Twoim najlepszym wyniku",
						"sw": "## Matokeo Yaliyothibitishwa\n\nImezingatia matokeo yako bora",
						"tl": "## Mga Napatunayang Resulta\n\nNakatuon sa iyong pinakamahusay na resulta",
						"vi": "## Kết quả đã được chứng minh\n\nTập ​​trung vào kết quả tốt nhất cho bạn",
						"zh": "## 卓著成效\n\n专注于为您取得最佳成果"
					},
					"value": "## Proven Results\n\nFocused on your best outcome"
				}
			}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "خمس نجوم بيضاء",
						"en": "Five White Stars",
						"en-GB": "Five White Stars",
						"en-US": "Five White Stars",
						"es": "Cinco estrellas blancas",
						"es-419": "Cinco estrellas blancas",
						"es-ES": "Cinco estrellas blancas",
						"he": "חמישה כוכבים לבנים",
						"it": "Cinque stelle bianche",
						"pl": "Pięć białych gwiazd",
						"sw": "Nyota Tano Nyeupe",
						"tl": "Limang Puting Bituin",
						"vi": "Năm ngôi sao trắng",
						"zh": "五颗白星"
					},
					"value": "Five White Stars"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2001%2FFeature%2002%20Image%2FChatGPT%20Image%20Five%20Stars.png?alt=media&token=195ea39f-67a7-42d3-b9ad-9471089b2915",
				"formattedSize": "15.87 KB",
				"height": 62,
				"name": "ChatGPT Image Five Stars.png",
				"path": "uploads/home/Features 01/Feature 02 Image/ChatGPT Image Five Stars.png",
				"query": "?as=run",
				"size": 16252,
				"type": "image/png",
				"updated": "2025-12-24T04:54:06.512Z",
				"width": 361
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## خبير\n\nأكثر من ٢٣ عامًا في قضايا القيادة تحت تأثير الكحول والدفاع الجنائي",
						"en": "## Experienced\n\n23+ years of DUI & Criminal Defense",
						"en-GB": "## Experienced\n\n23+ years of DUI & Criminal Defense",
						"en-US": "## Experienced\n\n23+ years of DUI & Criminal Defense",
						"es": "## Experiencia\n\nMás de 23 años de experiencia en DUI y defensa penal",
						"es-419": "## Experiencia\n\nMás de 23 años de experiencia en DUI y defensa penal",
						"es-ES": "## Experiencia\n\nMás de 23 años de experiencia en DUI y defensa penal",
						"he": "## ניסיון\n\nמעל 23 שנות ניסיון בהגנה פלילית ועבירות נהיגה בשכרות",
						"it": "## Esperienza\n\nOltre 23 anni di esperienza nella difesa penale e per guida in stato di ebbrezza",
						"pl": "## Doświadczony\n\nPonad 23 lata doświadczenia w sprawach DUI i obronie karnej",
						"sw": "## Uzoefu\n\nMiaka 23+ ya Uendeshaji wa Dui na Ulinzi wa Jinai",
						"tl": "## May Karanasan\n\n23+ taon ng DUI at Depensa sa Kriminal",
						"vi": "## Giàu kinh nghiệm\n\nHơn 23 năm kinh nghiệm bào chữa các vụ án lái xe trong tình trạng say xỉn và các vụ án",
						"zh": "## 经验丰富\n\n拥有超过 23 年的酒驾及刑事辩护经验"
					},
					"value": "## Experienced\n\n23+ years of DUI & Criminal Defense"
				}
			}
		},
		"Feature 03 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "خمس نجوم بيضاء",
						"en": "Five White Stars",
						"en-GB": "Five White Stars",
						"en-US": "Five White Stars",
						"es": "Cinco estrellas blancas",
						"es-419": "Cinco estrellas blancas",
						"es-ES": "Cinco estrellas blancas",
						"he": "חמישה כוכבים לבנים",
						"it": "Cinque stelle bianche",
						"pl": "Pięć białych gwiazd",
						"sw": "Nyota Tano Nyeupe",
						"tl": "Limang Puting Bituin",
						"vi": "Năm ngôi sao trắng",
						"zh": "五颗白星"
					},
					"value": "Five White Stars"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2001%2FFeature%2003%20Image%2FChatGPT%20Image%20Five%20Stars.png?alt=media&token=db941d2a-7af4-43b9-9979-3d53ef249a76",
				"formattedSize": "15.87 KB",
				"height": 62,
				"name": "ChatGPT Image Five Stars.png",
				"path": "uploads/home/Features 01/Feature 03 Image/ChatGPT Image Five Stars.png",
				"query": "?as=run",
				"size": 16252,
				"type": "image/png",
				"updated": "2025-12-24T04:55:02.691Z",
				"width": 361
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## التركيز على العميل\n\nستبقى على اطلاع دائم بكل خطوة.",
						"en": "## Client-Focused\n\nYou’ll stay informed every step of the way",
						"en-GB": "## Client-Focused\n\nYou’ll stay informed every step of the way",
						"en-US": "## Client-Focused\n\nYou’ll stay informed every step of the way",
						"es": "## Centrado en el cliente\n\nTe mantendremos informado en cada paso del proceso.",
						"es-419": "## Centrado en el cliente\n\nTe mantendremos informado en cada paso del proceso.",
						"es-ES": "## Centrado en el cliente\n\nTe mantendremos informado en cada paso del proceso.",
						"he": "## ממוקד לקוח\n\nתישאר מעודכן בכל שלב בדרך",
						"it": "## Orientato al cliente\n\nRimarrai informato in ogni fase del percorso",
						"pl": "## Skoncentrowany na kliencie\n\nBędziesz na bieżąco informowany na każdym etapie",
						"sw": "## Kuzingatia Mteja\n\nUtaendelea kupata taarifa kila hatua",
						"tl": "## Nakatuon sa Kliyente\n\nMananatiling may alam ka sa bawat hakbang",
						"vi": "## Tập trung vào khách hàng\n\nBạn sẽ luôn được cập nhật thông tin ở mọi giai đoạn.",
						"zh": "## 以客户为中心\n\n您将全程了解项目进展。"
					},
					"value": "## Client-Focused\n\nYou’ll stay informed every step of the way"
				}
			}
		},
		"Feature 04 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "خمس نجوم بيضاء",
						"en": "Five White Stars",
						"en-GB": "Five White Stars",
						"en-US": "Five White Stars",
						"es": "Cinco estrellas blancas",
						"es-419": "Cinco estrellas blancas",
						"es-ES": "Cinco estrellas blancas",
						"he": "חמישה כוכבים לבנים",
						"it": "Cinque stelle bianche",
						"pl": "Pięć białych gwiazd",
						"sw": "Nyota Tano Nyeupe",
						"tl": "Limang Puting Bituin",
						"vi": "Năm ngôi sao trắng",
						"zh": "五颗白星"
					},
					"value": "Five White Stars"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2001%2FFeature%2004%20Image%2FChatGPT%20Image%20Five%20Stars.png?alt=media&token=11fae14e-be72-40ec-a81a-2b1fb49c494b",
				"formattedSize": "15.87 KB",
				"height": 62,
				"name": "ChatGPT Image Five Stars.png",
				"path": "uploads/home/Features 01/Feature 04 Image/ChatGPT Image Five Stars.png",
				"query": "?as=run",
				"size": 16252,
				"type": "image/png",
				"updated": "2025-12-24T04:55:17.730Z",
				"width": 361
			}
		},
		"Feature 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## ميزة محلية\n\nعلى بُعد خطوات من المحكمة، مع روابط قوية بالمجتمع القانوني",
						"en": "## Local Advantage\n\nSteps from the courthouse with strong legal community ties",
						"en-GB": "## Local Advantage\n\nSteps from the courthouse with strong legal community ties",
						"en-US": "## Local Advantage\n\nSteps from the courthouse with strong legal community ties",
						"es": "Ventaja local\n\nA pasos del juzgado y con sólidos vínculos con la comunidad jurídica.",
						"es-419": "Ventaja local\n\nA pasos del juzgado y con sólidos vínculos con la comunidad jurídica.",
						"es-ES": "Ventaja local\n\nA pasos del juzgado y con sólidos vínculos con la comunidad jurídica.",
						"he": "## יתרון מקומי\n\nבמרחק צעדים ספורים מבית המשפט עם קשרים משפטיים חזקים בקהילה",
						"it": "## Vantaggio locale\n\nA pochi passi dal tribunale, con forti legami con la comunità legale",
						"pl": "## Lokalna przewaga\n\nKilka kroków od sądu, z silnymi powiązaniami ze społecznością prawniczą",
						"sw": "## Faida ya Eneo\n\nHatua kutoka mahakamani zenye uhusiano imara wa kijamii wa kisheria",
						"tl": "## Lokal na Kalamangan\n\nMalapit lang sa korte na may matibay na ugnayan sa legal na komunidad",
						"vi": "## Lợi thế địa phương\n\nGần tòa án, có mối liên hệ chặt chẽ với cộng đồng pháp lý",
						"zh": "## 本地优势\n\n毗邻法院，与法律界人士联系紧密"
					},
					"value": "## Local Advantage\n\nSteps from the courthouse with strong legal community ties"
				}
			}
		},
		"Feature 05 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "خمس نجوم بيضاء",
						"en": "Five White Stars",
						"en-GB": "Five White Stars",
						"en-US": "Five White Stars",
						"es": "Cinco estrellas blancas",
						"es-419": "Cinco estrellas blancas",
						"es-ES": "Cinco estrellas blancas",
						"he": "חמישה כוכבים לבנים",
						"it": "Cinque stelle bianche",
						"pl": "Pięć białych gwiazd",
						"sw": "Nyota Tano Nyeupe",
						"tl": "Limang Puting Bituin",
						"vi": "Năm ngôi sao trắng",
						"zh": "五颗白星"
					},
					"value": "Five White Stars"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2001%2FFeature%2005%20Image%2FChatGPT%20Image%20Five%20Stars.png?alt=media&token=acb75834-3d64-48c5-af52-0cab2ca8ddf1",
				"formattedSize": "15.87 KB",
				"height": 62,
				"name": "ChatGPT Image Five Stars.png",
				"path": "uploads/home/Features 01/Feature 05 Image/ChatGPT Image Five Stars.png",
				"query": "?as=run",
				"size": 16252,
				"type": "image/png",
				"updated": "2025-12-24T04:52:21.090Z",
				"width": 361
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-2 sm:py-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 text-center"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 xl:grid-cols-5"
				},
				"imageClass": {
					"translations": {},
					"value": "w-24 mx-auto my-2 sm:my-4"
				},
				"titleClass": {
					"translations": {},
					"value": "hidden"
				}
			}
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "02",
				"en-GB": "02",
				"en-US": "02",
				"es": "02",
				"es-419": "02",
				"es-ES": "02",
				"sw": "02",
				"zh": "02"
			},
			"type": "TextInput",
			"value": "02"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "سمات",
				"en": "Features",
				"en-GB": "Features",
				"en-US": "Features",
				"es": "Características",
				"es-419": "Características",
				"es-ES": "Características",
				"he": "תכונות",
				"it": "Caratteristiche",
				"pl": "Cechy",
				"sw": "Vipengele",
				"tl": "Mga Tampok",
				"vi": "Đặc trưng",
				"zh": "特征"
			},
			"type": "TextInput",
			"value": "Features"
		}
	},
	"Features 02": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "أكثر من ٢٣ عامًا\n\nرضا العملاء",
						"en": "23+ Years\n\nClient Satisfaction",
						"en-GB": "23+ Years\n\nClient Satisfaction",
						"en-US": "23+ Years\n\nClient Satisfaction",
						"es": "Más de 23 años de experiencia\n\nSatisfacción del cliente",
						"es-419": "Más de 23 años de experiencia\n\nSatisfacción del cliente",
						"es-ES": "Más de 23 años de experiencia\n\nSatisfacción del cliente",
						"he": "23+ שנים\n\nשביעות רצון לקוחות",
						"it": "Oltre 23 anni\n\nSoddisfazione del cliente",
						"pl": "Ponad 23 lata\n\nSatysfakcja klienta",
						"sw": "Miaka 23+\n\nKuridhika kwa Mteja",
						"tl": "23+ Taon\n\nKasiyahan ng Kliyente",
						"vi": "Hơn 23 năm kinh nghiệm\n\nSự hài lòng của khách hàng",
						"zh": "23年以上经验\n\n客户满意度"
					},
					"value": "23+ Years\n\nClient Satisfaction"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "تظهر دائرة وعمود وإكليل غار على خلفية بيضاء.",
						"en": "A circle , a pillar , and a laurel wreath are shown on a white background.",
						"en-GB": "A circle , a pillar , and a laurel wreath are shown on a white background.",
						"en-US": "A circle , a pillar , and a laurel wreath are shown on a white background.",
						"es": "Sobre un fondo blanco se muestran un círculo, un pilar y una corona de laurel.",
						"es-419": "Sobre un fondo blanco se muestran un círculo, un pilar y una corona de laurel.",
						"es-ES": "Sobre un fondo blanco se muestran un círculo, un pilar y una corona de laurel.",
						"he": "עיגול, עמוד וזר דפנה מוצגים על רקע לבן.",
						"it": "Un cerchio, un pilastro e una corona d'alloro sono raffigurati su uno sfondo bianco.",
						"pl": "Na białym tle przedstawiono koło, kolumnę i wieniec laurowy.",
						"sw": "Duara, nguzo, na shada la maua ya laureli vinaonyeshwa kwenye mandhari nyeupe.",
						"tl": "Ang isang bilog, isang haligi, at isang koronang laurel ay ipinapakita sa isang puting background.",
						"vi": "Trên nền trắng, ta thấy hình tròn, cột trụ và vòng nguyệt quế.",
						"zh": "白色背景上的图案包括一个圆圈、一根柱子和一个月桂花环。"
					},
					"value": "A circle , a pillar , and a laurel wreath are shown on a white background."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2002%2FFeature%2001%20Image%2FAmber-Honors-trans-image-255w.png?alt=media&token=c1db3b3c-2384-44bd-8ce9-86d8ea0dd78c",
				"formattedSize": "28.04 KB",
				"height": 103,
				"name": "Amber-Honors-trans-image-255w.png",
				"path": "uploads/home/Features 02/Feature 01 Image/Amber-Honors-trans-image-255w.png",
				"query": "?as=run:0",
				"size": 28712,
				"type": "image/png",
				"updated": "2026-01-05T13:06:36.461Z",
				"width": 260
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "جائزة اختيار العملاء\n\n2022، 2023، 2024، و2025",
						"en": "Clients' Choice Award\n\n2022, '23, '24, & '25",
						"en-GB": "Clients' Choice Award\n\n2022, '23, '24, & '25",
						"en-US": "Clients' Choice Award\n\n2022, '23, '24, & '25",
						"es": "Premio de los Clientes\n\n2022, 2023, 2024 y 2025",
						"es-419": "Premio de los Clientes\n\n2022, 2023, 2024 y 2025",
						"es-ES": "Premio de los Clientes\n\n2022, 2023, 2024 y 2025",
						"he": "פרס בחירת הלקוחות\n\n2022, 2023, 2024 ו-2025",
						"it": "Premio Scelta del Cliente\n\n2022, 2023, 2024 e 2025",
						"pl": "Nagroda Klienta\n\n2022, '23, '24 i '25",
						"sw": "Tuzo ya Chaguo la Wateja\n\n2022, '23, '24, & '25",
						"tl": "Gantimpala sa Pagpili ng mga Kliyente\n\n2022, '23, '24, at '25",
						"vi": "Giải thưởng do Khách hàng bình chọn\n\n2022, 2023, 2024 & 2025",
						"zh": "客户选择奖\n\n2022、2023、2024 和 2025 年"
					},
					"value": "Clients' Choice Award\n\n2022, '23, '24, & '25"
				}
			}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "شارة تقول \"اختيار عملاء Avvo\" مع خمس نجوم",
						"en": "A badge that says avvo clients choice with five stars",
						"en-GB": "A badge that says avvo clients choice with five stars",
						"en-US": "A badge that says avvo clients choice with five stars",
						"es": "Una insignia que dice \"Elección del cliente de Avvo\" con cinco estrellas.",
						"es-419": "Una insignia que dice \"Elección del cliente de Avvo\" con cinco estrellas.",
						"es-ES": "Una insignia que dice \"Elección del cliente de Avvo\" con cinco estrellas.",
						"he": "תג שאומר \"בחירת הלקוחות של avvo\" עם חמישה כוכבים",
						"it": "Un badge che dice \"scelta del cliente Avvo\" con cinque stelle",
						"pl": "Odznaka z napisem „Wybór klientów Avvo” i pięcioma gwiazdkami",
						"sw": "Beji inayosema chaguo la wateja wa avvo yenye nyota tano",
						"tl": "Isang badge na nagsasabing pagpipilian ng mga kliyente ng avvo na may limang bituin",
						"vi": "Một huy hiệu ghi \"Sự lựa chọn của khách hàng Avvo\" với năm sao.",
						"zh": "一枚标有“avvo客户之选”五星标志的徽章"
					},
					"value": "A badge that says avvo clients choice with five stars"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2002%2FFeature%2002%20Image%2Favvo-badge.png?alt=media&token=bb6c3434-ab4f-4379-99d4-1dcd9adc0a2b",
				"formattedSize": "5.96 KB",
				"height": 228,
				"name": "avvo-badge.png",
				"path": "uploads/home/Features 02/Feature 02 Image/avvo-badge.png",
				"query": "?as=run:0",
				"size": 6099,
				"type": "image/png",
				"updated": "2025-12-08T21:34:37.121Z",
				"width": 256
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "خمس نجوم\n\nمراجعة جوجل",
						"en": "5 Stars\n\nGoogle Reviewed",
						"en-GB": "5 Stars\n\nGoogle Reviewed",
						"en-US": "5 Stars\n\nGoogle Reviewed",
						"es": "5 estrellas\n\nReseña de Google",
						"es-419": "5 estrellas\n\nReseña de Google",
						"es-ES": "5 estrellas\n\nReseña de Google",
						"he": "5 כוכבים\n\nביקורת בגוגל",
						"it": "5 stelle\n\nRecensione su Google",
						"pl": "5 gwiazdek\n\nRecenzowane przez Google",
						"sw": "Nyota 5\n\nIliyopitiwa na Google",
						"tl": "5 Bituin\n\nSinuri ng Google",
						"vi": "5 sao\n\nĐánh giá trên Google",
						"zh": "五星好评\n\n谷歌评论"
					},
					"value": "5 Stars\n\nGoogle Reviewed"
				}
			}
		},
		"Feature 03 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "شعار جوجل مكتوب عليه \"تقييمات جوجل من فئة 5 نجوم\"",
						"en": "A google logo that says 5 stars google reviews",
						"en-GB": "A google logo that says 5 stars google reviews",
						"en-US": "A google logo that says 5 stars google reviews",
						"es": "Un logotipo de Google que dice 5 estrellas en reseñas de Google.",
						"es-419": "Un logotipo de Google que dice 5 estrellas en reseñas de Google.",
						"es-ES": "Un logotipo de Google que dice 5 estrellas en reseñas de Google.",
						"he": "לוגו של גוגל שאומר ביקורות גוגל 5 כוכבים",
						"it": "Un logo di Google che dice 5 stelle nelle recensioni di Google",
						"pl": "Logo Google z napisem „5 gwiazdek, recenzje Google”",
						"sw": "Nembo ya google inayosema nyota 5 maoni ya google",
						"tl": "Isang logo ng Google na nagsasabing 5 bituin mga review ng Google",
						"vi": "Logo của Google có dòng chữ \"5 sao đánh giá của Google\"",
						"zh": "一个写着“5 星 Google 评论”的 Google 标志"
					},
					"value": "A google logo that says 5 stars google reviews"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2002%2FFeature%2003%20Image%2Fgoogle-reviews-1500x640-blue-Reviews-600w.png?alt=media&token=537b343d-a52d-466a-b765-162178f99eaa",
				"formattedSize": "79.47 KB",
				"height": 256,
				"name": "google-reviews-1500x640-blue-Reviews-600w.png",
				"path": "uploads/home/Features 02/Feature 03 Image/google-reviews-1500x640-blue-Reviews-600w.png",
				"query": "?as=run:0",
				"size": 81382,
				"type": "image/png",
				"updated": "2025-12-08T22:13:34.494Z",
				"width": 600
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "خمس نجوم\n\nمراجعة من Avvo",
						"en": "5 Stars\n\nAvvo Reviewed",
						"en-GB": "5 Stars\n\nAvvo Reviewed",
						"en-US": "5 Stars\n\nAvvo Reviewed",
						"es": "5 estrellas\n\nReseña de Avvo",
						"es-419": "5 estrellas\n\nReseña de Avvo",
						"es-ES": "5 estrellas\n\nReseña de Avvo",
						"he": "5 כוכבים\n\nביקורת על Avvo",
						"it": "5 stelle\n\nRecensione di Avvo",
						"pl": "5 gwiazdek\n\nRecenzja Avvo",
						"sw": "Nyota 5\n\nAvvo Imepitiwa",
						"tl": "5 Bituin\n\nSinuri ang Avvo",
						"vi": "5 sao\n\nĐánh giá trên Avvo",
						"zh": "五星好评\n\nAvvo 评测"
					},
					"value": "5 Stars\n\nAvvo Reviewed"
				}
			}
		},
		"Feature 04 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "تقييم Avvo: 10.0، أفضل محامية لأمبر بيلانتي",
						"en": "Avvo rating 10.0 Top Attorney for Amber Bellante",
						"en-GB": "Avvo rating 10.0 Top Attorney for Amber Bellante",
						"en-US": "Avvo rating 10.0 Top Attorney for Amber Bellante",
						"es": "Calificación Avvo 10.0 El mejor abogado para Amber Bellante",
						"es-419": "Calificación Avvo 10.0 El mejor abogado para Amber Bellante",
						"es-ES": "Calificación Avvo 10.0 El mejor abogado para Amber Bellante",
						"he": "דירוג Avvo 10.0 עורך דין מוביל עבור אמבר בלנטה",
						"it": "Valutazione Avvo 10.0 Miglior avvocato per Amber Bellante",
						"pl": "Ocena Avvo 10.0 Najlepszy prawnik Amber Bellante",
						"sw": "Ukadiriaji wa Avvo 10.0 Wakili Bora wa Amber Bellante",
						"tl": "Rating ng Avvo na 10.0 Nangungunang Abogado para kay Amber Bellante",
						"vi": "Xếp hạng Avvo 10.0 Luật sư hàng đầu cho Amber Bellante",
						"zh": "Avvo 评分 10.0，Amber Bellante 的顶级律师"
					},
					"value": "Avvo rating 10.0 Top Attorney for Amber Bellante"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2002%2FFeature%2004%20Image%2FAvvo-Rating-10.0-Amber-Bellante-255w.png?alt=media&token=e273dcee-47fa-40bd-a9f0-1cdf356e6cff",
				"formattedSize": "48.02 KB",
				"height": 205,
				"name": "Avvo-Rating-10.0-Amber-Bellante-255w.png",
				"path": "uploads/home/Features 02/Feature 04 Image/Avvo-Rating-10.0-Amber-Bellante-255w.png",
				"query": "?as=run:0",
				"size": 49175,
				"type": "image/png",
				"updated": "2025-12-08T22:04:42.600Z",
				"width": 260
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-2 sm:py-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "py-2 sm:py-4 bg-linear-to-br from-base-300 via-transparent to-base-300 text-center"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
				},
				"imageClass": {
					"translations": {},
					"value": "h-28 w-auto object-contain mx-auto"
				}
			}
		},
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "04",
				"en-GB": "04",
				"en-US": "04",
				"es": "04",
				"es-419": "04",
				"es-ES": "04",
				"sw": "04",
				"zh": "04"
			},
			"type": "TextInput",
			"value": "05"
		}
	},
	"Features 03": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "Sacramento County"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "رسم تخطيطي لمحكمة مقاطعة ساكرامنتو",
						"en": "Sacramento County Courthouse drawing",
						"en-GB": "Sacramento County Courthouse drawing",
						"en-US": "Sacramento County Courthouse drawing",
						"es": "Dibujo del Palacio de Justicia del Condado de Sacramento",
						"es-419": "Dibujo del Palacio de Justicia del Condado de Sacramento",
						"es-ES": "Dibujo del Palacio de Justicia del Condado de Sacramento",
						"he": "ציור של בית המשפט המחוזי של סקרמנטו",
						"it": "Disegno del tribunale della contea di Sacramento",
						"pl": "Rysunek budynku sądu hrabstwa Sacramento",
						"sw": "Mchoro wa Mahakama ya Kaunti ya Sacramento",
						"tl": "Guhit ng Hukuman ng Kondado ng Sacramento",
						"vi": "Bản vẽ Tòa án Quận Sacramento",
						"zh": "萨克拉门托县法院大楼图纸"
					},
					"value": "Sacramento County Courthouse drawing"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2003%2FFeature%2001%20Image%2Fsacramento-courthouse-drawing-600x400.jpg?alt=media&token=4990784c-3779-463a-a178-3df11211f85d",
				"formattedSize": "122.70 KB",
				"height": 400,
				"name": "sacramento-courthouse-drawing-600x400.jpg",
				"path": "uploads/home/Features 03/Feature 01 Image/sacramento-courthouse-drawing-600x400.jpg",
				"query": "?as=run",
				"size": 125644,
				"type": "image/jpeg",
				"updated": "2025-12-26T19:50:02.009Z",
				"width": 600
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "Placer County"
				}
			}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "محكمة أوبورن التاريخية في كاليفورنيا",
						"en": "Auburn California Historic Courthouse ",
						"en-GB": "Auburn California Historic Courthouse ",
						"en-US": "Auburn California Historic Courthouse ",
						"es": "Palacio de justicia histórico de Auburn, California",
						"es-419": "Palacio de justicia histórico de Auburn, California",
						"es-ES": "Palacio de justicia histórico de Auburn, California",
						"he": "בית המשפט ההיסטורי של אובורן, קליפורניה",
						"it": "Tribunale storico di Auburn, California",
						"pl": "Historyczny budynek sądu w Auburn w Kalifornii",
						"sw": "Mahakama ya Kihistoria ya Auburn California",
						"tl": "Makasaysayang Hukuman ng Auburn California",
						"vi": "Tòa án lịch sử Auburn, California",
						"zh": "加州奥本历史法院"
					},
					"value": "Auburn California Historic Courthouse "
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2003%2FFeature%2002%20Image%2Fplacer-courthouse-600x400.jpg?alt=media&token=e69380f4-0b74-4703-88d6-4e210a5c0b81",
				"formattedSize": "73.26 KB",
				"height": 400,
				"name": "placer-courthouse-600x400.jpg",
				"path": "uploads/home/Features 03/Feature 02 Image/placer-courthouse-600x400.jpg",
				"query": "?as=run",
				"size": 75021,
				"type": "image/jpeg",
				"updated": "2025-12-26T19:59:26.137Z",
				"width": 600
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "El Dorado County"
				}
			}
		},
		"Feature 03 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "محكمة إلدورادو",
						"en": "El Dorado Courthouse",
						"en-GB": "El Dorado Courthouse",
						"en-US": "El Dorado Courthouse",
						"es": "Palacio de Justicia de El Dorado",
						"es-419": "Palacio de Justicia de El Dorado",
						"es-ES": "Palacio de Justicia de El Dorado",
						"he": "בית המשפט אל דוראדו",
						"it": "Tribunale di El Dorado",
						"pl": "Sąd El Dorado",
						"sw": "Mahakama ya El Dorado",
						"tl": "Hukuman ng El Dorado",
						"vi": "Tòa án El Dorado",
						"zh": "埃尔多拉多法院"
					},
					"value": "El Dorado Courthouse"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2003%2FFeature%2003%20Image%2Fel-dorado-courthouse-600x400.jpg?alt=media&token=e19c4413-dc50-4588-875a-fae50fd3002e",
				"formattedSize": "62.38 KB",
				"height": 400,
				"name": "el-dorado-courthouse-600x400.jpg",
				"path": "uploads/home/Features 03/Feature 03 Image/el-dorado-courthouse-600x400.jpg",
				"query": "?as=run",
				"size": 63873,
				"type": "image/jpeg",
				"updated": "2025-12-26T20:01:43.688Z",
				"width": 600
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "Yolo County"
				}
			}
		},
		"Feature 04 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "محكمة يولو",
						"en": "Yolo Courthouse",
						"en-GB": "Yolo Courthouse",
						"en-US": "Yolo Courthouse",
						"es": "Palacio de justicia de Yolo",
						"es-419": "Palacio de justicia de Yolo",
						"es-ES": "Palacio de justicia de Yolo",
						"he": "בית המשפט יולו",
						"it": "Tribunale di Yolo",
						"pl": "Sąd Yolo",
						"sw": "Mahakama ya Yolo",
						"tl": "Hukuman ng Yolo",
						"vi": "Tòa án Yolo",
						"zh": "尤洛县法院"
					},
					"value": "Yolo Courthouse"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2003%2FFeature%2004%20Image%2Fyolo-courthouse-600x400.jpg?alt=media&token=d22e9a1a-bf28-40eb-a7d1-7c04b142b885",
				"formattedSize": "79.32 KB",
				"height": 400,
				"name": "yolo-courthouse-600x400.jpg",
				"path": "uploads/home/Features 03/Feature 04 Image/yolo-courthouse-600x400.jpg",
				"query": "?as=run",
				"size": 81227,
				"type": "image/jpeg",
				"updated": "2025-12-26T20:03:49.717Z",
				"width": 600
			}
		},
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "جسر البرج الذهبي ونهر سكرامنتو في سكرامنتو، كاليفورنيا، تم تصويرهما من منتزه ريفر ووك ليلاً مع وجود النجوم في السماء.",
						"en": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-GB": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-US": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"es": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-419": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-ES": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"he": "גשר מגדל הזהב ונהר סקרמנטו בסקרמנטו, קליפורניה, צולם מפארק ריבר ווק בלילה עם כוכבים בשמיים.",
						"it": "Il Gold Tower Bridge e il fiume Sacramento a Sacramento, California, fotografati dal River Walk Park di notte con le stelle nel cielo.",
						"pl": "Most Gold Tower Bridge i rzeka Sacramento w Sacramento w Kalifornii, sfotografowane nocą z River Walk Park na tle rozgwieżdżonego nieba.",
						"sw": "Daraja la Mnara wa Dhahabu na Mto Sacramento huko Sacramento, California, vilipigwa picha kutoka Hifadhi ya Mto Walk usiku na nyota angani.",
						"tl": "Ang Gold Tower Bridge at ang Sacramento River sa Sacramento, California, na kinunan ng litrato mula sa River Walk Park sa gabi kasama ang mga bituin sa kalangitan.",
						"vi": "Cầu Tháp Vàng và sông Sacramento ở Sacramento, California, được chụp từ công viên River Walk vào ban đêm với bầu trời đầy sao.",
						"zh": "加利福尼亚州萨克拉门托市的金塔桥和萨克拉门托河，照片拍摄于夜晚的河滨公园，天空繁星点点。"
					},
					"value": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2003%2FbgImage%2Fshutterstock_2243996415-cropped.jpg?alt=media&token=b7f8c21a-36a9-447b-90ad-1ccc1094216b",
				"formattedSize": "567.15 KB",
				"height": 500,
				"name": "shutterstock_2243996415-cropped.jpg",
				"path": "uploads/home/Features 03/bgImage/shutterstock_2243996415-cropped.jpg",
				"query": "?as=run",
				"size": 580764,
				"type": "image/jpeg",
				"updated": "2025-12-23T09:55:44.849Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "grayscale opacity-30 w-full"
				},
				"contentClass": {
					"translations": {},
					"value": "py-24"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "mx-auto text-center"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
				},
				"imageClass": {
					"translations": {},
					"value": "h-32 w-auto object-contain mx-auto rounded"
				}
			}
		},
		"index": 4,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "06"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "نفخر بتقديم خدماتنا",
				"en": "Proudly Serving",
				"en-GB": "Proudly Serving",
				"en-US": "Proudly Serving",
				"es": "Sirviendo con orgullo",
				"es-419": "Sirviendo con orgullo",
				"es-ES": "Sirviendo con orgullo",
				"he": "מגישים בגאווה",
				"it": "Serviamo con orgoglio",
				"pl": "Z dumą służymy",
				"sw": "Kuhudumia kwa Fahari",
				"tl": "Buong Pagmamalaking Naglilingkod",
				"vi": "Tự hào phục vụ",
				"zh": "竭诚为您服务"
			},
			"type": "TextInput",
			"value": "Proudly Serving"
		}
	},
	"Features 05": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## اطلب رفض الدعوى\n\nعن طريق الطعن في الأخطاء الإجرائية، وعدم كفاية الأدلة، وانتهاكات حقوقك.",
						"en": "## Seek Case Dismissal\n\nby challenging procedural errors, insufficient evidence, and violations of your rights.",
						"en-GB": "## Seek Case Dismissal\n\nby challenging procedural errors, insufficient evidence, and violations of your rights.",
						"en-US": "## Seek Case Dismissal\n\nby challenging procedural errors, insufficient evidence, and violations of your rights.",
						"es": "Solicitar la desestimación del caso\n\nimpugnando errores de procedimiento, pruebas insuficientes y violaciones de sus derechos.",
						"es-419": "Solicitar la desestimación del caso\n\nimpugnando errores de procedimiento, pruebas insuficientes y violaciones de sus derechos.",
						"es-ES": "Solicitar la desestimación del caso\n\nimpugnando errores de procedimiento, pruebas insuficientes y violaciones de sus derechos.",
						"he": "## לבקש דחיית תיק\n\nעל ידי ערעור על שגיאות פרוצדורליות, ראיות לא מספקות והפרות של זכויותיך.",
						"it": "## Richiedi l'archiviazione del caso\n\ncontestando errori procedurali, prove insufficienti e violazioni dei tuoi diritti.",
						"pl": "## Ubiegaj się o umorzenie sprawy\n\nkwestionując błędy proceduralne, niewystarczające dowody i naruszenia Twoich praw.",
						"sw": "## Tafuta Kufukuzwa kwa Kesi\n\nkwa kupinga makosa ya kiutaratibu, ushahidi usiotosha, na ukiukwaji wa haki zako.",
						"tl": "## Humingi ng Pagbabasura ng Kaso\n\nsa pamamagitan ng paghamon sa mga pagkakamali sa pamamaraan, hindi sapat na ebidensya, at mga paglabag sa iyong mga karapatan.",
						"vi": "## Yêu cầu bác bỏ vụ kiện\n\nbằng cách phản đối các sai sót về thủ tục, bằng chứng không đầy đủ và vi phạm quyền của bạn.",
						"zh": "## 寻求驳回案件\n\n通过质疑程序错误、证据不足以及侵犯您的权利等理由。"
					},
					"value": "## Seek Case Dismissal\n\nby challenging procedural errors, insufficient evidence, and violations of your rights."
				},
				"title": {
					"translations": {
						"ar": "أنا.",
						"en": "I.",
						"en-GB": "I.",
						"en-US": "I.",
						"es": "I.",
						"es-419": "I.",
						"es-ES": "I.",
						"he": "אֲנִי.",
						"it": "IO.",
						"pl": "I.",
						"sw": "Mimi.",
						"tl": "Ako.",
						"vi": "TÔI.",
						"zh": "我。"
					},
					"value": "I."
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## تخفيض الرسوم\n\nعن طريق التفاوض الاستراتيجي والحجج القانونية المقنعة.",
						"en": "## Reduce Charges\n\nthrough strategic negotiation and compelling legal arguments.",
						"en-GB": "## Reduce Charges\n\nthrough strategic negotiation and compelling legal arguments.",
						"en-US": "## Reduce Charges\n\nthrough strategic negotiation and compelling legal arguments.",
						"es": "## Reducir cargos\n\nmediante una negociación estratégica y argumentos legales convincentes.",
						"es-419": "## Reducir cargos\n\nmediante una negociación estratégica y argumentos legales convincentes.",
						"es-ES": "## Reducir cargos\n\nmediante una negociación estratégica y argumentos legales convincentes.",
						"he": "## הפחתת חיובים\n\nבאמצעות משא ומתן אסטרטגי וטיעונים משפטיים משכנעים.",
						"it": "## Ridurre le spese\n\nattraverso negoziazioni strategiche e argomentazioni legali convincenti.",
						"pl": "## Obniż koszty\n\npoprzez strategiczne negocjacje i przekonujące argumenty prawne.",
						"sw": "## Punguza Ada\n\nkupitia mazungumzo ya kimkakati na hoja za kisheria zenye kushawishi.",
						"tl": "## Bawasan ang mga Singil\n\nsa pamamagitan ng estratehikong negosasyon at mga nakakahimok na legal na argumento.",
						"vi": "## Giảm Chi phí\n\nthông qua đàm phán chiến lược và lập luận pháp lý thuyết phục.",
						"zh": "## 降低指控\n\n通过策略性谈判和令人信服的法律论据。"
					},
					"value": "## Reduce Charges\n\nthrough strategic negotiation and compelling legal arguments."
				},
				"title": {
					"translations": {
						"ar": "ثانياً.",
						"en": "II.",
						"en-GB": "II.",
						"en-US": "II.",
						"es": "II.",
						"es-419": "II.",
						"es-ES": "II.",
						"he": "ב'.",
						"it": "II.",
						"pl": "II.",
						"sw": "II.",
						"tl": "II.",
						"vi": "II.",
						"zh": "二、"
					},
					"value": "II."
				}
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## قدّم قضيتك إلى المحكمة\n\nمن خلال الطعن بقوة في قضية الادعاء والسعي للحصول على حكم بالبراءة.",
						"en": "## Take Your Case to Trial\n\nby rigorously challenging the prosecution's case and fighting for a Not Guilty verdict.",
						"en-GB": "## Take Your Case to Trial\n\nby rigorously challenging the prosecution's case and fighting for a Not Guilty verdict.",
						"en-US": "## Take Your Case to Trial\n\nby rigorously challenging the prosecution's case and fighting for a Not Guilty verdict.",
						"es": "## Lleve su caso a juicio\n\nimpugnando rigurosamente el caso de la fiscalía y luchando por un veredicto de inocencia.",
						"es-419": "## Lleve su caso a juicio\n\nimpugnando rigurosamente el caso de la fiscalía y luchando por un veredicto de inocencia.",
						"es-ES": "## Lleve su caso a juicio\n\nimpugnando rigurosamente el caso de la fiscalía y luchando por un veredicto de inocencia.",
						"he": "## הבא את התיק שלך למשפט\n\nעל ידי ערעור קפדני על טענת התביעה ונאבק למען פסק דין זכות.",
						"it": "## Porta il tuo caso in tribunale\n\nimpugnando con fermezza le tesi dell'accusa e lottando per un verdetto di non colpevolezza.",
						"pl": "## Doprowadź swoją sprawę do rozprawy\n\nkonsekwentnie kwestionując argumenty prokuratury i walcząc o wyrok uniewinniający.",
						"sw": "## Pitisha Kesi Yako Mahakamani\n\nkwa kupinga vikali kesi ya upande wa mashtaka na kupigania hukumu ya kutokuwa na hatia.",
						"tl": "## Dalhin ang Iyong Kaso sa Paglilitis\n\nsa pamamagitan ng mahigpit na paghamon sa kaso ng prosekusyon at pakikipaglaban para sa isang hatol na Not Guilty.",
						"vi": "## Đưa vụ án ra xét xử\n\nbằng cách kiên quyết phản bác lập luận của bên công tố và đấu tranh để được tuyên bố vô tội.",
						"zh": "## 将案件提交审判\n\n通过对检方指控进行严格质疑，争取无罪判决。"
					},
					"value": "## Take Your Case to Trial\n\nby rigorously challenging the prosecution's case and fighting for a Not Guilty verdict."
				},
				"title": {
					"translations": {
						"ar": "ثالثًا.",
						"en": "III.",
						"en-GB": "III.",
						"en-US": "III.",
						"es": "III.",
						"es-419": "III.",
						"es-ES": "III.",
						"he": "ג'.",
						"it": "III.",
						"pl": "III.",
						"sw": "III.",
						"tl": "III.",
						"vi": "III.",
						"zh": "三、"
					},
					"value": "III."
				}
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {
						"ar": "## الدفاع بعد انتهاء القضية\n\nبإمكاني تقديم التماس للمحكمة لإسقاط إداناتك السابقة، وكذلك تقديم التماس لإغلاق ملف اعتقالاتك السابقة، في معظم الحالات.",
						"en": "## Post-Case Advocacy\n\nI can petition the court to have your prior convictions dismissed and also petition the court to seal your prior arrests, in most cases.",
						"en-GB": "## Post-Case Advocacy\n\nI can petition the court to have your prior convictions dismissed and also petition the court to seal your prior arrests, in most cases.",
						"en-US": "## Post-Case Advocacy\n\nI can petition the court to have your prior convictions dismissed and also petition the court to seal your prior arrests, in most cases.",
						"es": "## Defensa posterior al caso\n\nEn la mayoría de los casos, puedo solicitar al tribunal la desestimación de sus condenas previas y, en algunos casos, el cierre de sus arrestos previos.",
						"es-419": "## Defensa posterior al caso\n\nEn la mayoría de los casos, puedo solicitar al tribunal la desestimación de sus condenas previas y, en algunos casos, el cierre de sus arrestos previos.",
						"es-ES": "## Defensa posterior al caso\n\nEn la mayoría de los casos, puedo solicitar al tribunal la desestimación de sus condenas previas y, en algunos casos, el cierre de sus arrestos previos.",
						"he": "## ייעוץ לאחר משפט\n\nברוב המקרים אוכל לעתור לבית המשפט בבקשה לבטל את הרשעותיך הקודמות, וגם לעתור לבית המשפט לאטום את מעצריך הקודמים.",
						"it": "## Assistenza post-caso\n\nNella maggior parte dei casi, posso presentare istanza al tribunale per l'archiviazione delle vostre precedenti condanne e anche per la convalida dei vostri precedenti arresti.",
						"pl": "## Rzecznictwo po sprawie\n\nW większości przypadków mogę złożyć wniosek do sądu o umorzenie wcześniejszych wyroków skazujących, a także o zatajenie wcześniejszych aresztowań.",
						"sw": "## Utetezi Baada ya Kesi\n\nNinaweza kuiomba mahakama ifute hukumu zako za awali na pia kuiomba mahakama ifunge kukamatwa kwako hapo awali, katika visa vingi.",
						"tl": "## Pagtatanggol Pagkatapos ng Kaso\n\nMaaari akong magpetisyon sa korte na ibasura ang iyong mga naunang hatol at magpetisyon din sa korte na selyuhan ang iyong mga naunang pag-aresto, sa karamihan ng mga kaso.",
						"vi": "## Hỗ trợ sau khi kết thúc vụ án\n\nTôi có thể đệ đơn lên tòa án để yêu cầu xóa bỏ các bản án trước đây của bạn và cũng có thể đệ đơn lên tòa án để niêm phong hồ sơ bắt giữ trước đây của bạn, trong hầu hết các trường hợp.",
						"zh": "## 案件后续支持\n\n在大多数情况下，我可以向法院申请撤销您之前的定罪记录，也可以申请封存您之前的逮捕记录。"
					},
					"value": "## Post-Case Advocacy\n\nI can petition the court to have your prior convictions dismissed and also petition the court to seal your prior arrests, in most cases."
				},
				"title": {
					"translations": {
						"ar": "رابعاً.",
						"en": "IV.",
						"en-GB": "IV.",
						"en-US": "IV.",
						"es": "IV.",
						"es-419": "IV.",
						"es-ES": "IV.",
						"he": "ד'.",
						"it": "IV.",
						"pl": "IV.",
						"sw": "IV.",
						"tl": "IV.",
						"vi": "IV.",
						"zh": "四、"
					},
					"value": "IV."
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-24"
				},
				"featureClass": {
					"translations": {},
					"value": "leading-loose"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "w-1/2 lg:w-1/4  px-2 sm:px-4 text-base-content bg-linear-to-br from-base-300 via-transparent to-base-300"
				},
				"featureTitleClass": {
					"translations": {},
					"value": "text-xl sm:text-2xl md:text-3xl xl:text-5xl"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap"
				},
				"iconClass": {
					"translations": {},
					"value": "m-0"
				},
				"titleClass": {
					"translations": {},
					"value": "hidden"
				}
			}
		},
		"index": 5,
		"markedContent": {
			"permission": "Admin",
			"translations": {
				"ar": "أقوم بتحليل كل جانب من جوانب قضيتك بدقة متناهية للطعن في الأدلة، وتحديد نقاط الضعف في قضية الادعاء، والسعي بكل جدية لتحقيق أفضل نتيجة ممكنة.\n\nأولويتي هي:",
				"en": "### I meticulously analyze every aspect of your case to challenge the evidence, identify weaknesses in the prosecution's case, and aggressively pursue the best possible outcome.\n﻿\n### My priority is to:",
				"en-GB": "### I meticulously analyze every aspect of your case to challenge the evidence, identify weaknesses in the prosecution's case, and aggressively pursue the best possible outcome.\n﻿\n### My priority is to:",
				"en-US": "### I meticulously analyze every aspect of your case to challenge the evidence, identify weaknesses in the prosecution's case, and aggressively pursue the best possible outcome.\n﻿\n### My priority is to:",
				"es": "Analizo meticulosamente cada aspecto de su caso para cuestionar la evidencia, identificar las debilidades de la fiscalía y buscar con ahínco el mejor resultado posible.\n\nMi prioridad es:",
				"es-419": "Analizo meticulosamente cada aspecto de su caso para cuestionar la evidencia, identificar las debilidades de la fiscalía y buscar con ahínco el mejor resultado posible.\n\nMi prioridad es:",
				"es-ES": "Analizo meticulosamente cada aspecto de su caso para cuestionar la evidencia, identificar las debilidades de la fiscalía y buscar con ahínco el mejor resultado posible.\n\nMi prioridad es:",
				"he": "### אני מנתח בקפידה כל היבט של התיק שלך כדי לערער על הראיות, לזהות חולשות בתיק התביעה ולחתור באגרסיביות לתוצאה הטובה ביותר האפשרית.\n\n### העדיפות שלי היא:",
				"it": "### Analizzo meticolosamente ogni aspetto del tuo caso per contestare le prove, identificare i punti deboli della tesi dell'accusa e perseguire con determinazione il miglior risultato possibile.\n\n### La mia priorità è:",
				"pl": "### Skrupulatnie analizuję każdy aspekt Twojej sprawy, aby podważyć dowody, zidentyfikować słabe punkty oskarżenia i zdecydowanie dążyć do uzyskania jak najlepszego wyniku.\n﻿\n### Moim priorytetem jest:",
				"sw": "### Ninachambua kwa makini kila kipengele cha kesi yako ili kupinga ushahidi, kubaini udhaifu katika kesi ya upande wa mashtaka, na kutafuta kwa bidii matokeo bora zaidi.\n\n### Kipaumbele changu ni:",
				"tl": "### Masusing sinusuri ko ang bawat aspeto ng iyong kaso upang hamunin ang ebidensya, tukuyin ang mga kahinaan sa kaso ng prosekusyon, at agresibong hinahangad ang pinakamahusay na posibleng resulta.\n\n### Ang aking prayoridad ay:",
				"vi": "Tôi phân tích tỉ mỉ mọi khía cạnh trong vụ án của bạn để phản bác bằng chứng, xác định điểm yếu trong lập luận của bên công tố và tích cực theo đuổi kết quả tốt nhất có thể.\n\nƯu tiên của tôi là:",
				"zh": "我会仔细分析您案件的每一个细节，质疑证据，找出控方证据的薄弱环节，并积极争取最佳结果。\n\n我的首要任务是："
			},
			"type": "TextArea",
			"value": "### I meticulously analyze every aspect of your case to challenge the evidence, identify weaknesses in the prosecution's case, and aggressively pursue the best possible outcome.\n﻿\n### My priority is to:"
		},
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "07",
				"en-GB": "07",
				"en-US": "07",
				"es": "07",
				"es-419": "07",
				"es-ES": "07",
				"sw": "07",
				"zh": "07"
			},
			"type": "TextInput",
			"value": "08"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "الأولويات",
				"en": "Priorities",
				"en-GB": "Priorities",
				"en-US": "Priorities",
				"es": "Prioridades",
				"es-419": "Prioridades",
				"es-ES": "Prioridades",
				"he": "סדרי עדיפויות",
				"it": "Priorità",
				"pl": "Priorytety",
				"sw": "Vipaumbele",
				"tl": "Mga Prayoridad",
				"vi": "Ưu tiên",
				"zh": "优先事项"
			},
			"type": "TextInput",
			"value": "Priorities"
		}
	},
	"Features 06": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"content": {
					"translations": {
						"en": "## I strive to achieve the best possible outcome for Each and Every client.\n\n*Attorney Amber Bellante*",
						"en-GB": "## I strive to achieve the best possible outcome for Each and Every client.\n\n*Attorney Amber Bellante*",
						"en-US": "## I strive to achieve the best possible outcome for Each and Every client.\n\n*Attorney Amber Bellante*",
						"es": "Me esfuerzo por lograr el mejor resultado posible para cada cliente.\n\n*Abogada Amber Bellante*",
						"es-419": "Me esfuerzo por lograr el mejor resultado posible para cada cliente.\n\n*Abogada Amber Bellante*",
						"es-ES": "Me esfuerzo por lograr el mejor resultado posible para cada cliente.\n\n*Abogada Amber Bellante*",
						"sw": "## Ninajitahidi kufikia matokeo bora zaidi kwa Kila mteja.\n\n*Wakili Amber Bellante*",
						"zh": "我致力于为每一位客户争取最佳结果。\n\n*律师 Amber Bellante*"
					},
					"value": "## I strive to achieve the best possible outcome for Each and Every client.\n\n*Attorney Amber Bellante*"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk.",
						"en-GB": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk.",
						"en-US": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk.",
						"es": "Edificio moderno estilo juzgado, con altas columnas blancas, paredes de vidrio y gente caminando por una espaciosa plaza de entrada al aire libre al anochecer.",
						"es-419": "Edificio moderno estilo juzgado, con altas columnas blancas, paredes de vidrio y gente caminando por una espaciosa plaza de entrada al aire libre al anochecer.",
						"es-ES": "Edificio moderno estilo juzgado, con altas columnas blancas, paredes de vidrio y gente caminando por una espaciosa plaza de entrada al aire libre al anochecer.",
						"sw": "Jengo la kisasa la mtindo wa mahakama lenye nguzo ndefu nyeupe, kuta za vioo, na watu wanaotembea kwenye eneo kubwa la kuingilia eneo la wazi jioni.",
						"zh": "现代法院式建筑，高耸的白色柱子，玻璃墙，黄昏时分，人们穿过宽敞的露天入口广场。"
					},
					"value": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2006%2FFeature%2001%20Image%2Fpexels-photo-11170499-1293w-c500.webp?alt=media&token=9ec73bb3-a076-470c-a696-5f0f9635a8f5",
				"formattedSize": "62.03 KB",
				"height": 500,
				"name": "pexels-photo-11170499-1293w-c500.webp",
				"path": "uploads/home/Features 06/Feature 01 Image/pexels-photo-11170499-1293w-c500.webp",
				"query": "?as=run",
				"size": 63522,
				"type": "image/webp",
				"updated": "2025-12-10T04:46:44.066Z",
				"width": 1290
			}
		},
		"imageClass": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "rounded mx-auto"
		},
		"index": 6,
		"maxWidth": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "w-full rounded"
		},
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": ""
		}
	},
	"Features Article Grid": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-24"
				},
				"featureClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center gap-2 sm:gap-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 m-2 sm:m-4 p-2 sm:p-4 w-80"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center"
				},
				"imageClass": {
					"translations": {},
					"value": "h-48 object-contain mx-auto rounded"
				},
				"previewHeightClass": {
					"translations": {},
					"value": "h-24"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 7,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "11"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "الأخبار والتحديثات",
				"en": "News & Updates",
				"en-GB": "News & Updates",
				"en-US": "News & Updates",
				"es": "Noticias y actualizaciones",
				"es-419": "Noticias y actualizaciones",
				"es-ES": "Noticias y actualizaciones",
				"he": "חדשות ועדכונים",
				"it": "Notizie e aggiornamenti",
				"pl": "Aktualności i aktualizacje",
				"sw": "Habari na Masasisho",
				"tl": "Balita at Mga Update",
				"vi": "Tin tức & Cập nhật",
				"zh": "新闻与动态"
			},
			"type": "TextInput",
			"value": "News & Updates"
		}
	},
	"Features Memberships": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "الرابطة الوطنية لمحامي الدفاع الجنائي",
						"en": "National Association of Criminal Defense Lawyers",
						"en-GB": "National Association of Criminal Defense Lawyers",
						"en-US": "National Association of Criminal Defense Lawyers",
						"es": "Asociación Nacional de Abogados de Defensa Penal",
						"es-419": "Asociación Nacional de Abogados de Defensa Penal",
						"es-ES": "Asociación Nacional de Abogados de Defensa Penal",
						"he": "האיגוד הלאומי של עורכי דין להגנה פלילית",
						"it": "Associazione nazionale degli avvocati penalisti",
						"pl": "Krajowe Stowarzyszenie Adwokatów Obrony Karnej",
						"sw": "Chama cha Kitaifa cha Wanasheria wa Utetezi wa Jinai",
						"tl": "Pambansang Asosasyon ng mga Abogado sa Depensang Kriminal",
						"vi": "Hiệp hội Luật sư bào chữa hình sự quốc gia",
						"zh": "全国刑事辩护律师协会"
					},
					"value": "National Association of Criminal Defense Lawyers"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "شعار الرابطة الوطنية لمحامي الدفاع الجنائي",
						"en": "National Association of Criminal Defense Lawyers Banner",
						"en-GB": "National Association of Criminal Defense Lawyers Banner",
						"en-US": "National Association of Criminal Defense Lawyers Banner",
						"es": "Banner de la Asociación Nacional de Abogados de Defensa Penal",
						"es-419": "Banner de la Asociación Nacional de Abogados de Defensa Penal",
						"es-ES": "Banner de la Asociación Nacional de Abogados de Defensa Penal",
						"he": "באנר האיגוד הלאומי של עורכי דין להגנה פלילית",
						"it": "Stendardo dell'Associazione Nazionale degli Avvocati Penalisti",
						"pl": "Krajowe Stowarzyszenie Adwokatów Obrony Karnej Banner",
						"sw": "Bango la Chama cha Kitaifa cha Wanasheria wa Utetezi wa Jinai",
						"tl": "Banner ng Pambansang Asosasyon ng mga Abogado sa Depensang Kriminal",
						"vi": "Biểu ngữ của Hiệp hội Luật sư bào chữa hình sự quốc gia",
						"zh": "全国刑事辩护律师协会横幅"
					},
					"value": "National Association of Criminal Defense Lawyers Banner"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Memberships%2FFeature%2001%20Image%2Fpath1.png?alt=media&token=046c8b89-237e-4ac5-9021-695d00bf1746",
				"formattedSize": "27.12 KB",
				"height": 413,
				"name": "path1.png",
				"path": "uploads/home/Features Memberships/Feature 01 Image/path1.png",
				"query": "?as=run",
				"size": 27772,
				"type": "image/png",
				"updated": "2026-03-31T21:32:03.224Z",
				"width": 400
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "رابطة محامي قضايا القيادة تحت تأثير الكحول في كاليفورنيا",
						"en": "California DUI Lawyers Association",
						"en-GB": "California DUI Lawyers Association",
						"en-US": "California DUI Lawyers Association",
						"es": "Asociación de Abogados de California especializados en casos de DUI (conducción bajo los efectos del alcohol)",
						"es-419": "Asociación de Abogados de California especializados en casos de DUI (conducción bajo los efectos del alcohol)",
						"es-ES": "Asociación de Abogados de California especializados en casos de DUI (conducción bajo los efectos del alcohol)",
						"he": "איגוד עורכי הדין לנהיגה תחת השפעת אלכוהול בקליפורניה",
						"it": "Associazione degli avvocati specializzati in guida in stato di ebbrezza della California",
						"pl": "Kalifornijskie Stowarzyszenie Prawników ds. Jazdy pod wpływem alkoholu",
						"sw": "Chama cha Wanasheria wa Kuendesha Gari la Kusafirisha Watu kwa Magari ya California",
						"tl": "Asosasyon ng mga Abogado sa DUI sa California",
						"vi": "Hiệp hội Luật sư DUI California",
						"zh": "加州酒驾律师协会"
					},
					"value": "California DUI Lawyers Association"
				}
			}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "شعار رابطة محامي قضايا القيادة تحت تأثير الكحول في كاليفورنيا",
						"en": "California DUI Lawyers Association Banner",
						"en-GB": "California DUI Lawyers Association Banner",
						"en-US": "California DUI Lawyers Association Banner",
						"es": "Banner de la Asociación de Abogados de California especializados en casos de DUI (conducción bajo los efectos del alcohol)",
						"es-419": "Banner de la Asociación de Abogados de California especializados en casos de DUI (conducción bajo los efectos del alcohol)",
						"es-ES": "Banner de la Asociación de Abogados de California especializados en casos de DUI (conducción bajo los efectos del alcohol)",
						"he": "באנר של איגוד עורכי הדין לנהיגה בשכרות בקליפורניה",
						"it": "Stendardo dell'Associazione degli avvocati specializzati in guida in stato di ebbrezza della California",
						"pl": "Banner Stowarzyszenia Prawników ds. Jazdy pod wpływem alkoholu w Kalifornii",
						"sw": "Bango la Chama cha Wanasheria wa Kuendesha Gari la Kubebea Wagonjwa wa Kudunda Miguu cha California",
						"tl": "Banner ng Samahan ng mga Abogado ng DUI sa California",
						"vi": "Biểu ngữ của Hiệp hội Luật sư DUI California",
						"zh": "加州酒驾律师协会横幅"
					},
					"value": "California DUI Lawyers Association Banner"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Memberships%2FFeature%2002%20Image%2Flogo.webp?alt=media&token=c5016ac2-88a0-4ffe-a092-ebcbd283dca6",
				"formattedSize": "23.56 KB",
				"height": 116,
				"name": "logo.webp",
				"path": "uploads/home/Features Memberships/Feature 02 Image/logo.webp",
				"query": "?as=run:0",
				"size": 24130,
				"type": "image/webp",
				"updated": "2026-03-31T06:02:20.002Z",
				"width": 400
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "عضو مجلس إدارة قسم الممارسات الصغيرة الفردية",
						"en": "Solo Small Practice Division Board Member",
						"en-GB": "Solo Small Practice Division Board Member",
						"en-US": "Solo Small Practice Division Board Member",
						"es": "Miembro de la Junta Directiva de la División de Pequeñas Prácticas en Solitario",
						"es-419": "Miembro de la Junta Directiva de la División de Pequeñas Prácticas en Solitario",
						"es-ES": "Miembro de la Junta Directiva de la División de Pequeñas Prácticas en Solitario",
						"he": "חבר מועצת המנהלים של מחלקת המרפאות הקטנות סולו",
						"it": "Membro del consiglio di amministrazione della divisione Small Practice di Solo",
						"pl": "Członek zarządu Solo Small Practice Division",
						"sw": "Mwanachama wa Bodi ya Kitengo cha Mazoezi Madogo ya Mtu Mmoja",
						"tl": "Miyembro ng Lupon ng Dibisyon ng Maliit na Praktis na Nag-iisa",
						"vi": "Thành viên Hội đồng Phân khu Hành nghề Cá nhân Nhỏ",
						"zh": "独立小型诊所部门董事会成员"
					},
					"value": "Sacramento County Bar Association"
				}
			}
		},
		"Feature 03 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "شعار نقابة المحامين في مقاطعة ساكرامنتو",
						"en": "Sacramento County Bar Association Banner",
						"en-GB": "Sacramento County Bar Association Banner",
						"en-US": "Sacramento County Bar Association Banner",
						"es": "Banner de la Asociación de Abogados del Condado de Sacramento",
						"es-419": "Banner de la Asociación de Abogados del Condado de Sacramento",
						"es-ES": "Banner de la Asociación de Abogados del Condado de Sacramento",
						"he": "דגל לשכת עורכי הדין של מחוז סקרמנטו",
						"it": "Stendardo dell'Ordine degli Avvocati della Contea di Sacramento",
						"pl": "Sztandar Stowarzyszenia Adwokackiego Hrabstwa Sacramento",
						"sw": "Bango la Chama cha Wanasheria wa Kaunti ya Sacramento",
						"tl": "Banner ng Samahan ng mga Abogado ng Kondado ng Sacramento",
						"vi": "Biểu ngữ của Hiệp hội Luật sư Quận Sacramento",
						"zh": "萨克拉门托县律师协会横幅"
					},
					"value": "Sacramento County Bar Association Banner"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Memberships%2FFeature%2003%20Image%2FSCBA%2Blogo%2B2020%2BWhite.webp?alt=media&token=cd6679c7-a467-4a37-99dc-05729359aab5",
				"formattedSize": "20.49 KB",
				"height": 397,
				"name": "SCBA+logo+2020+White.webp",
				"path": "uploads/home/Features Memberships/Feature 03 Image/SCBA+logo+2020+White.webp",
				"query": "?as=run",
				"size": 20980,
				"type": "image/webp",
				"updated": "2026-03-31T02:44:04.747Z",
				"width": 1200
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "عضو مجلس إدارة قسم الممارسات الصغيرة في نقابة المحامين في سكرامنتو",
						"en": "Sacramento Bar Association Small Practice Division Board member",
						"en-GB": "Sacramento Bar Association Small Practice Division Board member",
						"en-US": "Sacramento Bar Association Small Practice Division Board member",
						"es": "Miembro de la junta directiva de la División de Pequeños Despachos de la Asociación de Abogados de Sacramento",
						"es-419": "Miembro de la junta directiva de la División de Pequeños Despachos de la Asociación de Abogados de Sacramento",
						"es-ES": "Miembro de la junta directiva de la División de Pequeños Despachos de la Asociación de Abogados de Sacramento",
						"he": "חבר מועצת המנהלים של מחלקת הלשכה הקטנה של עורכי הדין בסקרמנטו",
						"it": "Membro del consiglio direttivo della divisione per gli studi legali di piccole dimensioni dell'Ordine degli avvocati di Sacramento.",
						"pl": "Członek zarządu Wydziału Małej Praktyki Izby Adwokackiej w Sacramento",
						"sw": "Mwanachama wa Bodi ya Chama cha Wanasheria cha Sacramento Bar",
						"tl": "Miyembro ng Lupon ng Small Practice Division ng Sacramento Bar Association",
						"vi": "Thành viên hội đồng phân ban hành nghề luật sư quy mô nhỏ của Hiệp hội Luật sư Sacramento",
						"zh": "萨克拉门托律师协会小型律师事务所分会理事"
					},
					"value": "Sacramento Bar Association Small Practice Division Board member"
				}
			}
		},
		"Feature 04 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "شعار قسم الممارسات الفردية الصغيرة",
						"en": "Solo Small Practice Division Banner",
						"en-GB": "Solo Small Practice Division Banner",
						"en-US": "Solo Small Practice Division Banner",
						"es": "Banner de la División de Práctica Individual para Pequeños Consultorios",
						"es-419": "Banner de la División de Práctica Individual para Pequeños Consultorios",
						"es-ES": "Banner de la División de Práctica Individual para Pequeños Consultorios",
						"he": "באנר חטיבת תרגול קטן סולו",
						"it": "Banner della divisione Studio Legale Individuale di Piccole Dimensioni",
						"pl": "Baner dywizji Solo Small Practice",
						"sw": "Bango la Kitengo cha Mazoezi Madogo ya Mtu Mmoja",
						"tl": "Banner ng Solo Small Practice Division",
						"vi": "Biểu ngữ của Phân khu Thực hành Nhỏ Cá nhân",
						"zh": "单人小型练习组横幅"
					},
					"value": "Solo Small Practice Division Banner"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Memberships%2FFeature%2004%20Image%2FSSPD%2Blogo%2Bweb%2Bcopy.webp?alt=media&token=7066cb2d-ad20-4ee1-b9b4-d4ab6e25ec32",
				"formattedSize": "52.47 KB",
				"height": 233,
				"name": "SSPD+logo+web+copy.webp",
				"path": "uploads/home/Features Memberships/Feature 04 Image/SSPD+logo+web+copy.webp",
				"query": "?as=run",
				"size": 53728,
				"type": "image/webp",
				"updated": "2026-03-31T02:47:24.525Z",
				"width": 750
			}
		},
		"Feature 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"ar": "نقابة المحامين في مقاطعة سان دييغو",
						"en": "San Diego County Bar Association",
						"en-GB": "San Diego County Bar Association",
						"en-US": "San Diego County Bar Association",
						"es": "Colegio de Abogados del Condado de San Diego",
						"es-419": "Colegio de Abogados del Condado de San Diego",
						"es-ES": "Colegio de Abogados del Condado de San Diego",
						"he": "לשכת עורכי הדין של מחוז סן דייגו",
						"it": "Associazione degli avvocati della contea di San Diego",
						"pl": "Izba Adwokacka Hrabstwa San Diego",
						"sw": "Chama cha Wanasheria wa Kaunti ya San Diego",
						"tl": "Samahan ng Abogado ng Kondado ng San Diego",
						"vi": "Hiệp hội Luật sư Quận San Diego",
						"zh": "圣地亚哥县律师协会"
					},
					"value": "California Lawyers Association"
				}
			}
		},
		"Feature 05 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "شعار رابطة المحامين في كاليفورنيا",
						"en": "California Lawyers Association Banner",
						"en-GB": "California Lawyers Association Banner",
						"en-US": "California Lawyers Association Banner",
						"es": "Banner de la Asociación de Abogados de California",
						"es-419": "Banner de la Asociación de Abogados de California",
						"es-ES": "Banner de la Asociación de Abogados de California",
						"he": "דגל איגוד עורכי הדין של קליפורניה",
						"it": "Stendardo dell'Associazione degli avvocati della California",
						"pl": "Sztandar Stowarzyszenia Prawników Kalifornii",
						"sw": "Bango la Chama cha Wanasheria cha California",
						"tl": "Banner ng Samahan ng mga Abogado ng California",
						"vi": "Biểu ngữ của Hiệp hội Luật sư California",
						"zh": "加州律师协会横幅"
					},
					"value": "California Lawyers Association Banner"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Memberships%2FFeature%2005%20Image%2Frgb_cla_gradient_cropped.png?alt=media&token=a3fca81b-694c-4533-9a01-6981164c4411",
				"formattedSize": "13.98 KB",
				"height": 538,
				"name": "rgb_cla_gradient_cropped.png",
				"path": "uploads/home/Features Memberships/Feature 05 Image/rgb_cla_gradient_cropped.png",
				"query": "?as=run",
				"size": 14317,
				"type": "image/png",
				"updated": "2026-03-31T02:49:39.252Z",
				"width": 684
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-2 sm:py-4"
				},
				"featureClass": {
					"translations": {},
					"value": "flex flex-col justify-between gap-2 sm:gap-4 h-full text-2xl"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "p-2 sm:p-4 bg-linear-to-br from-base-300 via-transparent to-base-300 text-center"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 xl:grid-cols-5"
				},
				"imageClass": {
					"translations": {},
					"value": "h-24 w-auto object-contain mx-auto"
				},
				"titleClass": {
					"translations": {},
					"value": "hidden"
				}
			}
		},
		"index": 8,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "04"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "العضويات والجوائز",
				"en": "Memberships & Awards",
				"en-GB": "Memberships & Awards",
				"en-US": "Memberships & Awards",
				"es": "Membresías y premios",
				"es-419": "Membresías y premios",
				"es-ES": "Membresías y premios",
				"he": "חברות ופרסים",
				"it": "Associazioni e premi",
				"pl": "Członkostwa i nagrody",
				"sw": "Uanachama na Tuzo",
				"tl": "Mga Pagiging Miyembro at Mga Parangal",
				"vi": "Hội viên & Giải thưởng",
				"zh": "会员资格及奖项"
			},
			"type": "TextInput",
			"value": "Memberships & Awards"
		}
	},
	"Features Services Grid": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-24"
				},
				"featureClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center gap-2 sm:gap-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 m-2 sm:m-4 p-2 sm:p-4"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 md:grid-cols-3"
				},
				"imageClass": {
					"translations": {},
					"value": "hidden"
				},
				"previewHeightClass": {
					"translations": {},
					"value": "h-16"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "services"
		},
		"index": 9,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "07"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مجالات الممارسة",
				"en": "Areas of Practice",
				"en-GB": "Areas of Practice",
				"en-US": "Areas of Practice",
				"es": "Áreas de práctica",
				"es-419": "Áreas de práctica",
				"es-ES": "Áreas de práctica",
				"he": "תחומי עיסוק",
				"it": "Aree di pratica",
				"pl": "Obszary praktyki",
				"sw": "Maeneo ya Utendaji",
				"tl": "Mga Larangan ng Pagsasagawa",
				"vi": "Các lĩnh vực thực hành",
				"zh": "执业领域"
			},
			"type": "TextInput",
			"value": "Areas of Practice"
		}
	},
	"Head": {
		"index": 10,
		"ldjson": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"@type": {
					"translations": {
						"ar": "صفحة على الإنترنت",
						"en": "WebPage",
						"en-GB": "WebPage",
						"en-US": "WebPage",
						"es": "Página web",
						"es-419": "Página web",
						"es-ES": "Página web",
						"he": "דף אינטרנט",
						"it": "Pagina Web",
						"pl": "Strona internetowa",
						"sw": "Ukurasa wa Wavuti",
						"tl": "Webpage",
						"vi": "Trang web",
						"zh": "网页"
					},
					"value": "WebPage"
				}
			}
		},
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "00"
		}
	},
	"PageBanner": {
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"en": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"en-GB": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"en-US": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"es": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"es-419": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"es-ES": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"he": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+רחוב+בית+בית+סוויטה+672,+סקרמנטו,+קליפורניה+95814",
						"it": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"pl": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"sw": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"tl": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"vi": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814",
						"zh": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814"
					},
					"value": "https://www.google.com/maps?client=firefox-b-1-d&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYNbLvcq0ZqAMdXFNQ9cEfXB&daddr=901+H+St+Suite+672,+Sacramento,+CA+95814"
				},
				"label": {
					"translations": {
						"ar": "تفضل بزيارة شركتنا",
						"en": "Visit Our Firm",
						"en-GB": "Visit Our Firm",
						"en-US": "Visit Our Firm",
						"es": "Visita nuestra firma",
						"es-419": "Visita nuestra firma",
						"es-ES": "Visita nuestra firma",
						"he": "בקרו במשרד שלנו",
						"it": "Visita il nostro studio",
						"pl": "Odwiedź naszą firmę",
						"sw": "Tembelea Kampuni Yetu",
						"tl": "Bisitahin ang Aming Kumpanya",
						"vi": "Hãy ghé thăm công ty chúng tôi",
						"zh": "访问我们公司"
					},
					"value": "Visit Our Firm"
				}
			}
		},
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FPageBanner%2FbgImage%2Fshutterstock_1092700045-first-frame.jpg?alt=media&token=7692dfd1-fbdb-4c61-ac57-ae655c46d726",
				"formattedSize": "212.48 KB",
				"height": 500,
				"name": "shutterstock_1092700045-first-frame.jpg",
				"path": "uploads/home/PageBanner/bgImage/shutterstock_1092700045-first-frame.jpg",
				"query": "?as=run",
				"size": 217582,
				"type": "image/jpeg",
				"updated": "2025-12-20T23:12:01.294Z",
				"width": 1600
			}
		},
		"bgVideo": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FPageBanner%2FbgVideo%2Fshutterstock_1092700045.mp4?alt=media&token=260135f5-d2e4-4da6-bd79-ea3f267d32f7",
				"formattedSize": "4.28 MB",
				"height": 500,
				"name": "shutterstock_1092700045.mp4",
				"path": "uploads/home/PageBanner/bgVideo/shutterstock_1092700045.mp4",
				"query": "",
				"size": 4491390,
				"type": "video/mp4",
				"updated": "2025-12-20T23:13:05.583Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "relative text-nowrap text-sm sm:text-xl flex justify-center hover-ripple inline-block px-12 py-2 sm:py-4 mt-4"
				},
				"actionLayers": {
					"translations": {},
					"value": "absolute w-full h-full border-2 border-transparent bg-linear-to-r from-primary via-[#ffe7a4] to-primary left-1 -top-1, absolute w-full h-full border-2 border-transparent bg-linear-to-r from-primary via-[#ffe7a4] to-primary -left-1 top-1"
				},
				"bgImageClass": {
					"translations": {},
					"value": "opacity-20 grayscale w-full"
				}
			}
		},
		"index": 11,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		},
		"styles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionLayers": {
					"translations": {},
					"value": "mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;, mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;"
				},
				"image": {
					"translations": {},
					"value": "mask-image+:+ radial-gradient(ellipse,black 90%,transparent 70%);-webkit-mask-image+:+ radial-gradient(ellipse,black 50%,transparent 90%);"
				}
			}
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"ar": "الدفاع الجنائي في قضايا القيادة تحت تأثير الكحول في سكرامنتو",
				"en": "Sacramento ﻿DUI & Criminal Defense",
				"en-GB": "Sacramento ﻿DUI & Criminal Defense",
				"en-US": "Sacramento ﻿DUI & Criminal Defense",
				"es": "DUI y defensa criminal en Sacramento",
				"es-419": "DUI y defensa criminal en Sacramento",
				"es-ES": "DUI y defensa criminal en Sacramento",
				"he": "סקרמנטו ﻿נהיגה בשכרות והגנה פלילית",
				"it": "Sacramento ﻿Guida in stato di ebbrezza e difesa penale",
				"pl": "Sacramento DUI i obrona karna",
				"sw": "Sacramento ﻿DUI na Ulinzi wa Jinai",
				"tl": "Depensa sa DUI at Kriminalidad sa Sacramento",
				"vi": "Luật sư bào chữa về tội lái xe trong tình trạng say xỉn và các vụ án hình sự tại Sacramento.",
				"zh": "萨克拉门托酒驾及刑事辩护"
			},
			"type": "TextInput",
			"value": "Sacramento ﻿DUI & Criminal Defense"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مدفوع بالنتائج",
				"en": "Results Driven",
				"en-GB": "Results Driven",
				"en-US": "Results Driven",
				"es": "Orientado a resultados",
				"es-419": "Orientado a resultados",
				"es-ES": "Orientado a resultados",
				"he": "מונעי תוצאות",
				"it": "Risultati guidati",
				"pl": "Nastawiony na wyniki",
				"sw": "Matokeo Yanayotokana",
				"tl": "Mga Resulta na Pinapatakbo",
				"vi": "Định hướng kết quả",
				"zh": "结果导向"
			},
			"type": "TextInput",
			"value": "Results Driven"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"SideBySide 01": {
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "/حول-أمبر/",
						"en": "/About-Amber/",
						"en-GB": "/About-Amber/",
						"en-US": "/About-Amber/",
						"es": "/Acerca de Ámbar/",
						"es-419": "/Acerca de Ámbar/",
						"es-ES": "/Acerca de Ámbar/",
						"he": "/אודות-אמבר/",
						"it": "/Informazioni su Amber/",
						"pl": "/O-Amber/",
						"sw": "/Kuhusu-Kaharabu/",
						"tl": "/Tungkol-kay-Amber/",
						"vi": "/Giới thiệu về Amber/",
						"zh": "/关于琥珀/"
					},
					"value": "/About-Amber/"
				},
				"label": {
					"translations": {
						"ar": "نبذة عن آمبر",
						"en": "About Amber",
						"en-GB": "About Amber",
						"en-US": "About Amber",
						"es": "Acerca de Amber",
						"es-419": "Acerca de Amber",
						"es-ES": "Acerca de Amber",
						"he": "אודות אמבר",
						"it": "Informazioni su Amber",
						"pl": "O Amberze",
						"sw": "Kuhusu Amber",
						"tl": "Tungkol kay Amber",
						"vi": "Về Amber",
						"zh": "关于 Amber"
					},
					"value": "About Amber"
				}
			}
		},
		"bgAltBase": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		},
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "أفق مدينة سكرامنتو القديمة مع جسر البرج، منظر مدينة كاليفورنيا في الولايات المتحدة الأمريكية",
						"en": "Old town Sacramento city skyline with Tower Bridge, cityscape of California in  USA",
						"en-GB": "Old town Sacramento city skyline with Tower Bridge, cityscape of California in  USA",
						"en-US": "Old town Sacramento city skyline with Tower Bridge, cityscape of California in  USA",
						"es": "Horizonte del casco antiguo de la ciudad de Sacramento con el Puente de la Torre, paisaje urbano de California en EE. UU.",
						"es-419": "Horizonte del casco antiguo de la ciudad de Sacramento con el Puente de la Torre, paisaje urbano de California en EE. UU.",
						"es-ES": "Horizonte del casco antiguo de la ciudad de Sacramento con el Puente de la Torre, paisaje urbano de California en EE. UU.",
						"he": "קו הרקיע של העיר העתיקה של סקרמנטו עם גשר המגדל, נוף עירוני של קליפורניה בארה\"ב",
						"it": "Skyline della città vecchia di Sacramento con il Tower Bridge, paesaggio urbano della California negli Stati Uniti",
						"pl": "Panorama starego miasta Sacramento z Tower Bridge, panoramą Kalifornii w USA",
						"sw": "Mstari wa anga wa jiji la Sacramento la zamani lenye Daraja la Mnara, mandhari ya jiji la California nchini Marekani",
						"tl": "Lumang bayan ng Sacramento city skyline na may Tower Bridge, cityscape ng California sa USA",
						"vi": "Cảnh quan thành phố Sacramento cổ kính với Cầu Tháp London, quang cảnh thành phố California ở Hoa Kỳ.",
						"zh": "美国加利福尼亚州萨克拉门托老城区天际线，包括塔桥，展现了美国加利福尼亚州的城市风貌。"
					},
					"value": "Old town Sacramento city skyline with Tower Bridge, cityscape of California in  USA"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FSideBySide%2001%2FbgImage%2Fshutterstock_2611517511.jpg?alt=media&token=054b945f-f2a9-4e2c-85f2-8ab997f493e1",
				"formattedSize": "6.41 MB",
				"height": 2592,
				"name": "shutterstock_2611517511.jpg",
				"path": "uploads/home/SideBySide 01/bgImage/shutterstock_2611517511.jpg",
				"query": "?as=run",
				"size": 6720407,
				"type": "image/jpeg",
				"updated": "2025-12-19T22:48:40.542Z",
				"width": 4608
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "relative text-sm sm:text-xl flex items-center justify-center w-2/3 md:w-1/2 hover-ripple py-2 sm:py-4"
				},
				"actionLayers": {
					"translations": {},
					"value": "absolute w-full h-full border-2 border-transparent bg-linear-to-r from-primary via-[#ffe7a4] to-primary left-1 -top-1, absolute w-full h-full border-2 border-transparent bg-linear-to-r from-primary via-[#ffe7a4] to-primary -left-1 top-1"
				},
				"bgImageClass": {
					"translations": {},
					"value": "grayscale opacity-30"
				},
				"contentClass": {
					"translations": {},
					"value": "p-0"
				},
				"descriptionClass": {
					"translations": {},
					"value": "text-xl sm:text-2xl md:text-3xl xl:text-5xl my-auto leading-relaxed"
				},
				"imageClass": {
					"translations": {},
					"value": "block mx-auto w-120"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"ar": "- عازم\n\n- متفانٍ\n\n- مدفوع بالنتائج",
				"en": "- Determined\n- Dedicated\n- Driven By Results",
				"en-GB": "- Determined\n- Dedicated\n- Driven By Results",
				"en-US": "- Determined\n- Dedicated\n- Driven By Results",
				"es": "- Determinado\n- Dedicado\n- Impulsado por los resultados",
				"es-419": "- Determinado\n- Dedicado\n- Impulsado por los resultados",
				"es-ES": "- Determinado\n- Dedicado\n- Impulsado por los resultados",
				"he": "- נחוש\n- מסור\n- מונע על ידי תוצאות",
				"it": "- Determinato\n- Dedito\n- Spinto dai risultati",
				"pl": "- Zdeterminowany\n- Zaangażowany\n- Nastawiony na rezultaty",
				"sw": "- Imedhamiria\n- Imejitolea\n- Imeendeshwa na Matokeo",
				"tl": "- Determinado\n- Dedikado\n- Pinapatakbo ng mga Resulta",
				"vi": "- Quyết tâm\n- Tận tâm\n- Hướng đến kết quả",
				"zh": "- 坚定不移\n\n- 尽职尽责\n\n- 结果导向"
			},
			"type": "TextArea",
			"value": "- Determined\n- Dedicated\n- Driven By Results"
		},
		"flipped": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Photo of Sacramento Attorney Amber Bellante standing in front of a desk"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FSideBySide%2001%2Fimage%2FIMG_2571-lightfix-842x1100.jpg?alt=media&token=c1d691f3-7005-4180-ac77-f2a5b40ea4c6",
				"formattedSize": "144.52 KB",
				"height": 1100,
				"name": "IMG_2571-lightfix-842x1100.jpg",
				"path": "uploads/home/SideBySide 01/image/IMG_2571-lightfix-842x1100.jpg",
				"query": "?as=run",
				"size": 147988,
				"type": "image/jpeg",
				"updated": "2025-12-22T01:12:15.859Z",
				"width": 832
			}
		},
		"index": 12,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		},
		"styles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionLayers": {
					"translations": {},
					"value": "mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;, mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;"
				},
				"image": {
					"translations": {},
					"value": "mask-image+:+ radial-gradient(ellipse,black 90%,transparent 70%);-webkit-mask-image+:+ radial-gradient(ellipse,black 50%,transparent 90%);"
				}
			}
		}
	},
	"SideBySide 02": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "m-0 leading-loose"
				},
				"imageClass": {
					"translations": {},
					"value": "block mx-auto"
				},
				"titleClass": {
					"translations": {},
					"value": "block mt-8 lg:mt-0 lg:inline"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"ar": "أُقدّم دفاعًا قويًا وشخصيًا، ملتزمًا التزامًا راسخًا بحماية حقوقك ومستقبلك. بخبرة تزيد عن عقدين من الزمن، أعتمد نهجًا استراتيجيًا يركز على النتائج، ما يضمن حصول كل عميل على اهتمام مُخصّص واستراتيجية قانونية مُصممة خصيصًا له. على عكس مكاتب المحاماة الكبيرة، أُولي أهمية قصوى للتواصل الواضح، والدفاع المُستميت، وتحقيق أفضل النتائج الممكنة. باختيارك لي، أنت لا تُوكّل محاميًا فحسب، بل تكسب حليفًا قانونيًا موثوقًا يُدافع عن حقوقك بكل قوة.",
				"en": "I provide an aggressive, personalized defense with a deep commitment to protecting your rights and future. With over two decades of experience, I take a strategic, results-driven approach, ensuring every client receives dedicated attention and a tailored legal strategy. Unlike larger firms, I prioritize clear communication, relentless advocacy, and the best possible outcome. When you choose me, you're not just hiring a lawyer—you’re gaining a trusted legal ally who fights for you.",
				"en-GB": "I provide an aggressive, personalized defense with a deep commitment to protecting your rights and future. With over two decades of experience, I take a strategic, results-driven approach, ensuring every client receives dedicated attention and a tailored legal strategy. Unlike larger firms, I prioritize clear communication, relentless advocacy, and the best possible outcome. When you choose me, you're not just hiring a lawyer—you’re gaining a trusted legal ally who fights for you.",
				"en-US": "I provide an aggressive, personalized defense with a deep commitment to protecting your rights and future. With over two decades of experience, I take a strategic, results-driven approach, ensuring every client receives dedicated attention and a tailored legal strategy. Unlike larger firms, I prioritize clear communication, relentless advocacy, and the best possible outcome. When you choose me, you're not just hiring a lawyer—you’re gaining a trusted legal ally who fights for you.",
				"es": "Ofrezco una defensa agresiva y personalizada con un profundo compromiso con la protección de sus derechos y su futuro. Con más de dos décadas de experiencia, adopto un enfoque estratégico y orientado a resultados, garantizando que cada cliente reciba atención dedicada y una estrategia legal a su medida. A diferencia de las grandes firmas, priorizo la comunicación clara, la defensa incansable y el mejor resultado posible. Al elegirme, no solo contrata a un abogado, sino que también cuenta con un aliado legal de confianza que lucha por usted.",
				"es-419": "Ofrezco una defensa agresiva y personalizada con un profundo compromiso con la protección de sus derechos y su futuro. Con más de dos décadas de experiencia, adopto un enfoque estratégico y orientado a resultados, garantizando que cada cliente reciba atención dedicada y una estrategia legal a su medida. A diferencia de las grandes firmas, priorizo la comunicación clara, la defensa incansable y el mejor resultado posible. Al elegirme, no solo contrata a un abogado, sino que también cuenta con un aliado legal de confianza que lucha por usted.",
				"es-ES": "Ofrezco una defensa agresiva y personalizada con un profundo compromiso con la protección de sus derechos y su futuro. Con más de dos décadas de experiencia, adopto un enfoque estratégico y orientado a resultados, garantizando que cada cliente reciba atención dedicada y una estrategia legal a su medida. A diferencia de las grandes firmas, priorizo la comunicación clara, la defensa incansable y el mejor resultado posible. Al elegirme, no solo contrata a un abogado, sino que también cuenta con un aliado legal de confianza que lucha por usted.",
				"he": "אני מספק הגנה אגרסיבית ואישית עם מחויבות עמוקה להגנה על זכויותיכם ועתידכם. עם למעלה משני עשורים של ניסיון, אני נוקט בגישה אסטרטגית ומכוונת לתוצאות, ומבטיח שכל לקוח יקבל תשומת לב מסור ואסטרטגיה משפטית מותאמת אישית. בניגוד למשרדים גדולים יותר, אני שם עדיפות לתקשורת ברורה, ייצוג בלתי פוסק והתוצאה הטובה ביותר האפשרית. כשאתם בוחרים בי, אתם לא רק שוכרים עורך דין - אתם רוכשים בעל ברית משפטי מהימן שנלחם למענכם.",
				"it": "Offro una difesa aggressiva e personalizzata, con un profondo impegno a proteggere i vostri diritti e il vostro futuro. Con oltre vent'anni di esperienza, adotto un approccio strategico e orientato ai risultati, garantendo a ogni cliente un'attenzione dedicata e una strategia legale personalizzata. A differenza degli studi legali più grandi, do priorità a una comunicazione chiara, a un'assistenza costante e al miglior risultato possibile. Scegliendomi, non state solo assumendo un avvocato, ma state guadagnando un alleato legale di fiducia che combatte per voi.",
				"pl": "Oferuję agresywną, spersonalizowaną obronę z głębokim zaangażowaniem w ochronę Twoich praw i przyszłości. Dzięki ponad dwudziestoletniemu doświadczeniu stosuję strategiczne, zorientowane na rezultaty podejście, dbając o to, aby każdy klient otrzymał poświęconą uwagę i dopasowaną do jego potrzeb strategię prawną. W przeciwieństwie do większych kancelarii, priorytetem jest dla mnie jasna komunikacja, nieustanne wsparcie i jak najlepszy wynik. Wybierając mnie, nie zatrudniasz po prostu prawnika – zyskujesz zaufanego sojusznika prawnego, który walczy o Twoje interesy.",
				"sw": "Ninatoa utetezi mkali na wa kibinafsi na kujitolea kwa dhati kulinda haki zako na mustakabali wako. Kwa uzoefu wa zaidi ya miongo miwili, ninachukua mbinu ya kimkakati na inayozingatia matokeo, kuhakikisha kila mteja anapata umakini wa kujitolea na mkakati wa kisheria ulioundwa mahususi. Tofauti na makampuni makubwa, mimi hupa kipaumbele mawasiliano wazi, utetezi usiokoma, na matokeo bora iwezekanavyo. Unaponichagua, hauajiri tu wakili—unapata mshirika wa kisheria anayeaminika anayekupigania.",
				"tl": "Nagbibigay ako ng agresibo at personalized na depensa na may malalim na pangako sa pagprotekta sa iyong mga karapatan at kinabukasan. Taglay ang mahigit dalawang dekada ng karanasan, gumagamit ako ng estratehiko at nakabatay sa resultang pamamaraan, tinitiyak na ang bawat kliyente ay makakatanggap ng dedikadong atensyon at isang angkop na legal na estratehiya. Hindi tulad ng mas malalaking kumpanya, inuuna ko ang malinaw na komunikasyon, walang humpay na pagtataguyod, at ang pinakamagandang posibleng resulta. Kapag pinili mo ako, hindi ka lang basta kumukuha ng abogado—nakakakuha ka ng isang mapagkakatiwalaang legal na kakampi na lumalaban para sa iyo.",
				"vi": "Tôi cung cấp dịch vụ bào chữa mạnh mẽ, cá nhân hóa với cam kết sâu sắc bảo vệ quyền lợi và tương lai của bạn. Với hơn hai thập kỷ kinh nghiệm, tôi áp dụng phương pháp chiến lược, hướng đến kết quả, đảm bảo mỗi khách hàng đều nhận được sự quan tâm tận tâm và chiến lược pháp lý phù hợp. Khác với các công ty luật lớn, tôi ưu tiên giao tiếp rõ ràng, bảo vệ quyền lợi không ngừng nghỉ và kết quả tốt nhất có thể. Khi bạn chọn tôi, bạn không chỉ thuê một luật sư—mà còn có được một người đồng minh pháp lý đáng tin cậy, người sẽ chiến đấu vì bạn.",
				"zh": "我提供积极主动、个性化的辩护，致力于保护您的权利和未来。凭借二十余年的从业经验，我采取战略性、结果导向的方法，确保每位客户都能获得专属关注和量身定制的法律策略。与大型律师事务所不同，我优先考虑清晰的沟通、不懈的辩护以及争取最佳结果。选择我，您不仅仅是聘请了一位律师，更是获得了一位值得信赖的法律盟友，他会竭尽全力为您争取权益。"
			},
			"type": "TextArea",
			"value": "I provide an aggressive, personalized defense with a deep commitment to protecting your rights and future. With over two decades of experience, I take a strategic, results-driven approach, ensuring every client receives dedicated attention and a tailored legal strategy. Unlike larger firms, I prioritize clear communication, relentless advocacy, and the best possible outcome. When you choose me, you're not just hiring a lawyer—you’re gaining a trusted legal ally who fights for you."
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "مبنى حديث على طراز المحاكم، يتميز بأعمدة بيضاء طويلة وجدران زجاجية، وأشخاص يمرون عبر ساحة مدخل واسعة مفتوحة في الهواء الطلق عند الغسق.",
						"en": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk.",
						"en-GB": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk.",
						"en-US": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk.",
						"es": "Edificio moderno estilo juzgado, con altas columnas blancas, paredes de vidrio y gente caminando por una espaciosa plaza de entrada al aire libre al anochecer.",
						"es-419": "Edificio moderno estilo juzgado, con altas columnas blancas, paredes de vidrio y gente caminando por una espaciosa plaza de entrada al aire libre al anochecer.",
						"es-ES": "Edificio moderno estilo juzgado, con altas columnas blancas, paredes de vidrio y gente caminando por una espaciosa plaza de entrada al aire libre al anochecer.",
						"he": "בניין מודרני בסגנון בית משפט עם עמודים לבנים גבוהים, קירות זכוכית ואנשים הולכים דרך רחבת כניסה מרווחת תחת כיפת השמיים עם רדת החשיכה.",
						"it": "Moderno edificio in stile tribunale, con alte colonne bianche, pareti in vetro e persone che camminano attraverso un ampio piazzale d'ingresso all'aperto al tramonto.",
						"pl": "Nowoczesny budynek w stylu sądu z wysokimi białymi kolumnami, szklanymi ścianami i ludźmi przechadzającymi się o zmierzchu po przestronnym, otwartym placu wejściowym.",
						"sw": "Jengo la kisasa la mtindo wa mahakama lenye nguzo ndefu nyeupe, kuta za kioo, na watu wanaotembea kupitia uwanja mkubwa wa kuingilia wakati wa jioni.",
						"tl": "Modernong gusaling istilong korte na may matataas na puting haligi, mga dingding na salamin, at mga taong naglalakad sa isang maluwang na plaza na may bukas na pasukan pagsapit ng takipsilim.",
						"vi": "Tòa nhà theo phong cách tòa án hiện đại với những cột trắng cao, tường kính và người đi bộ qua quảng trường lối vào rộng rãi ngoài trời lúc hoàng hôn.",
						"zh": "现代法院式建筑，高耸的白色柱子，玻璃墙，黄昏时分，人们穿过宽敞的露天入口广场。"
					},
					"value": "Modern courthouse-style building with tall white columns, glass walls, and people walking through a spacious open-air entrance plaza at dusk."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FSideBySide%2002%2Fimage%2F113709_N2_indd-8200407e-1920w.webp?alt=media&token=ffb0981c-9dd7-4081-98b3-d6b82009df78",
				"formattedSize": "144.20 KB",
				"height": 938,
				"name": "113709_N2_indd-8200407e-1920w.webp",
				"path": "uploads/home/SideBySide 02/image/113709_N2_indd-8200407e-1920w.webp",
				"query": "?as=run",
				"size": 147660,
				"type": "image/webp",
				"updated": "2025-12-24T06:29:38.048Z",
				"width": 1500
			}
		},
		"index": 13,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "09"
		},
		"styles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"image": {
					"translations": {},
					"value": "mask-image+:+ radial-gradient(ellipse,black 90%,transparent 70%);-webkit-mask-image+:+ radial-gradient(ellipse,black 50%,transparent 90%);"
				}
			}
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "ما الذي يميزني؟",
				"en": "What Sets Me Apart?",
				"en-GB": "What Sets Me Apart?",
				"en-US": "What Sets Me Apart?",
				"es": "¿Qué me diferencia?",
				"es-419": "¿Qué me diferencia?",
				"es-ES": "¿Qué me diferencia?",
				"he": "מה מייחד אותי?",
				"it": "Cosa mi distingue?",
				"pl": "Co mnie wyróżnia?",
				"sw": "Ni Nini Kinachonitofautisha?",
				"tl": "Ano ang Nagpapaiba sa Akin?",
				"vi": "Điều gì khiến tôi khác biệt?",
				"zh": "我的独特之处是什么？"
			},
			"type": "TextInput",
			"value": "What Sets Me Apart?"
		}
	},
	"SideBySide 03": {
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "/اتصال/",
						"en": "/contact/",
						"en-GB": "/contact/",
						"en-US": "/contact/",
						"es": "/contacto/",
						"es-419": "/contacto/",
						"es-ES": "/contacto/",
						"he": "/מַגָע/",
						"it": "/contatto/",
						"pl": "/kontakt/",
						"sw": "/wasiliana/",
						"tl": "/makipag-ugnayan/",
						"vi": "/liên hệ/",
						"zh": "/接触/"
					},
					"value": "/contact/"
				},
				"label": {
					"translations": {
						"ar": "اتصل بنا",
						"en": "Contact Us",
						"en-GB": "Contact Us",
						"en-US": "Contact Us",
						"es": "Contáctenos",
						"es-419": "Contáctenos",
						"es-ES": "Contáctenos",
						"he": "צרו קשר",
						"it": "Contattaci",
						"pl": "Skontaktuj się z nami",
						"sw": "Wasiliana Nasi",
						"tl": "Makipag-ugnayan sa Amin",
						"vi": "Liên hệ với chúng tôi",
						"zh": "联系我们"
					},
					"value": "Contact Us"
				}
			}
		},
		"bgAltBase": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "relative text-sm sm:text-xl flex items-center justify-center w-2/3 md:w-1/2 hover-ripple p-2 sm:p-4"
				},
				"actionLayers": {
					"translations": {},
					"value": "absolute w-full h-full border-2 border-transparent bg-linear-to-r from-primary via-[#ffe7a4] to-primary left-1 -top-1, absolute w-full h-full border-2 border-transparent bg-linear-to-r from-primary via-[#ffe7a4] to-primary -left-1 top-1"
				},
				"contentClass": {
					"translations": {},
					"value": "m-0 leading-loose"
				},
				"imageClass": {
					"translations": {},
					"value": "block w-100 mx-auto"
				},
				"titleClass": {
					"translations": {},
					"value": "block mt-8 lg:mt-0 lg:inline"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"ar": "أسعى جاهداً لتحقيق أفضل النتائج الممكنة لكل عميل من خلال التعامل مع كل قضية بتركيز وتحضير وعناية.",
				"en": "I strive to achieve the best possible outcome for each and every client by approaching every case with focus, preparation and care.",
				"en-GB": "I strive to achieve the best possible outcome for each and every client by approaching every case with focus, preparation and care.",
				"en-US": "I strive to achieve the best possible outcome for each and every client by approaching every case with focus, preparation and care.",
				"es": "Me esfuerzo por lograr el mejor resultado posible para todos y cada uno de mis clientes al abordar cada caso con enfoque, preparación y cuidado.",
				"es-419": "Me esfuerzo por lograr el mejor resultado posible para todos y cada uno de mis clientes al abordar cada caso con enfoque, preparación y cuidado.",
				"es-ES": "Me esfuerzo por lograr el mejor resultado posible para todos y cada uno de mis clientes al abordar cada caso con enfoque, preparación y cuidado.",
				"he": "אני שואף להשיג את התוצאה הטובה ביותר עבור כל לקוח ולקוח על ידי גשת כל תיק בתשומת לב, הכנה ותשומת לב.",
				"it": "Mi impegno a raggiungere il miglior risultato possibile per ogni singolo cliente, affrontando ogni caso con attenzione, preparazione e cura.",
				"pl": "Dokładam wszelkich starań, aby zapewnić jak najlepszy wynik dla każdego klienta, dlatego do każdej sprawy podchodzę z zaangażowaniem, przygotowaniem i troską.",
				"sw": "Ninajitahidi kufikia matokeo bora zaidi kwa kila mteja kwa kushughulikia kila kesi kwa umakini, maandalizi na uangalifu.",
				"tl": "Sinisikap kong makamit ang pinakamahusay na posibleng resulta para sa bawat kliyente sa pamamagitan ng pagharap sa bawat kaso nang may pokus, paghahanda, at pag-iingat.",
				"vi": "Tôi luôn nỗ lực đạt được kết quả tốt nhất có thể cho mỗi khách hàng bằng cách tiếp cận từng vụ việc với sự tập trung, chuẩn bị kỹ lưỡng và cẩn trọng.",
				"zh": "我力求为每一位客户取得最佳结果，因此我会以专注、准备充分和认真负责的态度对待每一个案件。"
			},
			"type": "TextArea",
			"value": "I strive to achieve the best possible outcome for each and every client by approaching every case with focus, preparation and care."
		},
		"flipped": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "محامٍ متمرس يقف خارج المحكمة، يمثل موكليه بثقة واحترافية",
						"en": "Experienced attorney standing outside courthouse, representing clients with confidence and professionalism",
						"en-GB": "Experienced attorney standing outside courthouse, representing clients with confidence and professionalism",
						"en-US": "Experienced attorney standing outside courthouse, representing clients with confidence and professionalism",
						"es": "Abogado experimentado de pie afuera del tribunal, representando a clientes con confianza y profesionalismo.",
						"es-419": "Abogado experimentado de pie afuera del tribunal, representando a clientes con confianza y profesionalismo.",
						"es-ES": "Abogado experimentado de pie afuera del tribunal, representando a clientes con confianza y profesionalismo.",
						"he": "עורך דין מנוסה עומד מחוץ לבית המשפט, מייצג לקוחות בביטחון ובמקצועיות",
						"it": "Avvocato esperto in piedi fuori dal tribunale, che rappresenta i clienti con sicurezza e professionalità",
						"pl": "Doświadczony prawnik stojący przed budynkiem sądu, reprezentujący klientów z pewnością siebie i profesjonalizmem",
						"sw": "Wakili mwenye uzoefu amesimama nje ya mahakama, akiwawakilisha wateja kwa ujasiri na utaalamu",
						"tl": "Isang bihasang abogado na nakatayo sa labas ng korte, na kumakatawan sa mga kliyente nang may kumpiyansa at propesyonalismo",
						"vi": "Luật sư giàu kinh nghiệm đứng bên ngoài tòa án, tự tin và chuyên nghiệp đại diện cho khách hàng.",
						"zh": "经验丰富的律师站在法院外，自信而专业地代表客户。"
					},
					"value": "Experienced attorney standing outside courthouse, representing clients with confidence and professionalism"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fhome%2FSideBySide%2003%2Fimage%2FIMG_0052-cropped.jpg?alt=media&token=c3795afd-c5cd-4f68-b35d-87bc271d1ce9",
				"formattedSize": "127.86 KB",
				"height": 1039,
				"name": "IMG_0052-cropped.jpg",
				"path": "uploads/home/SideBySide 03/image/IMG_0052-cropped.jpg",
				"query": "?as=run",
				"size": 130933,
				"type": "image/jpeg",
				"updated": "2025-12-24T06:32:51.986Z",
				"width": 832
			}
		},
		"index": 14,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "10"
		},
		"styles": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionLayers": {
					"translations": {},
					"value": "mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;, mask+:+ linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite+:+ exclude;-webkit-mask-composite+:+ xor;"
				},
				"image": {
					"translations": {},
					"value": "mask-image+:+ radial-gradient(ellipse,black 90%,transparent 70%);-webkit-mask-image+:+ radial-gradient(ellipse,black 50%,transparent 90%);"
				}
			}
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مناصرة لا هوادة فيها. نتائج حقيقية.",
				"en": "Relentless Advocacy. Real Results.",
				"en-GB": "Relentless Advocacy. Real Results.",
				"en-US": "Relentless Advocacy. Real Results.",
				"es": "Defensa incansable. Resultados reales.",
				"es-419": "Defensa incansable. Resultados reales.",
				"es-ES": "Defensa incansable. Resultados reales.",
				"he": "הסברה בלתי פוסקת. תוצאות אמיתיות.",
				"it": "Difesa instancabile. Risultati concreti.",
				"pl": "Nieustanne orędownictwo. Prawdziwe rezultaty.",
				"sw": "Utetezi Usiokoma. Matokeo Halisi.",
				"tl": "Walang Huling Pagtataguyod. Tunay na mga Resulta.",
				"vi": "Kiên trì vận động. Kết quả thực tế.",
				"zh": "坚持不懈的倡导，带来切实成果。"
			},
			"type": "TextInput",
			"value": "Relentless Advocacy. Real Results."
		}
	},
	"Testimonials": {
		"index": 15,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "08"
		}
	}
}